//A handy little function to navigate back 1 page
function goBack() {
	window.history.back();
}

/**
 * If browser back button was used, flush cache
 * This ensures that user will always see an accurate, up-to-date view based on their state
 * https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked

Fixes issues with some loading="lazy" images not loading when clicking back button on iOS safari May 2022 - might want to review from time to time to see if this is still required

 */

var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

(function () {
	window.onpageshow = function(event) {
		if (event.persisted && iOS ) {
			window.location.reload();
		} 
	};
})();

function setCookie(cname,cvalue,exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname+"="+cvalue+"; "+expires+"; domain=.olliella.com; path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		} 
	}
	return "";
}


if ( getCookie("a-b-test") != "") { } else {
	random = parseInt(Math.random() * 2)
	setCookie("a-b-test", random, 1);
} 

if (getCookie("a-b-test-reported") == ""){
	setTimeout(function() {
		if (getCookie("a-b-test") == 0 ){
			ga('send', 'event', 'Test', 'A/B Split', 'Visitor - A', { nonInteraction: true });		
		} else {
			ga('send', 'event', 'Test', 'A/B Split', 'Visitor - B', { nonInteraction: true });
		}
		setCookie("a-b-test-reported", 'reported', 1);
	}, 1000);
} 


//Lazyloading for videos
var lazyVideos = [].slice.call(document.querySelectorAll('.lazy-video'));

if ("IntersectionObserver" in window) {
	var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(video) {
			if (video.isIntersecting) {
				for (var source in video.target.children) {
					var videoSource = video.target.children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
					}
				}

				video.target.load();
				video.target.classList.add("lazy-video");
				lazyVideoObserver.unobserve(video.target);
				

			}
		});
	});

	lazyVideos.forEach(function(lazyVideo) {
		lazyVideoObserver.observe(lazyVideo);
	});
}

//*---- GENERAL  ---*//

//Prevent click/tap on navigation dropdown menu items on touch screen
if ('ontouchstart' in window) {
	$(".dropdown--parent-link").click(function (e) {
		e.preventDefault();
	});
}

var pathname = window.location.pathname + window.location.search; 
// Returns path only
    
function storeSelection(region) {
	document.cookie = 'geo-incorrect' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=.olliella.com; path=/';		
	if ( store_location == region ) { 
		$('#store-selector-popup').fadeOut();
	} else {
		/*
		ga('send', 'event', { 
			eventCategory: 'Geo Location',
			eventAction: 'Redirect',
			eventLabel: 'Redirected'
		});*/
		
		if ( region == 'uk' ) {
			new_url = 'https://olliella.com'
		} else {
			new_url = 'https://'+region+'.olliella.com'
		}
		
		customer_cart = [];
		function cart_items(data){
			data.items.forEach(function(item) {
				item = {
					'handle': item.handle,
					'variant': item.variant_title,
					'qty': item.quantity
				}
				customer_cart.push(item);
			});
			
			setCookie("customer-cart", JSON.stringify(customer_cart), 1);
			window.top.location.href = new_url + pathname.split('?')[0]
			
		}

		//Get customer's cart and then redirect
		fetch(window.Shopify.routes.root + 'cart.js')
		  .then(response => response.json())
		  .then(data => cart_items(data) );		
	}
}

const eu_countries = 'AT BE BG HR CY CZ DK EE FI FR DE GR GG HU IT JE LV LT LU MT NL NO PL PT RO SK SI ES SE CH'
const uk_countries = 'AL AD AR AM BY BR EG IS IR IQ IE CL IM IL JO KW LB LI MX MD MC ME MK OM QA SM SA RS ZA TR UA GB AE'
const au_countries = 'AU HK JP KP KR MY NZ SG TW'
const us_countries = 'CA US'
const region_list = ["au","uk","eu","us"]
let regions_found = ''
let page_count = getCookie('page-count');


const regionQuery = new URLSearchParams(window.location.search).get('region');

if (regionQuery){
region = regionQuery;
setCookie('geo-location', regionQuery, 365);
}
else{
let region = getCookie("geo-location");
}

const geo_incorrect = getCookie("geo-incorrect");

if (page_count != "") { 
	setCookie('page-count', parseInt(page_count) + 1, 1);
} else {
	setCookie('page-count', 1, 1);
}

if ( page_count == 4 && geo_incorrect == 'yes' ) {
	$('#new-location').fadeIn();
}

$(document).ready(function() {
	if ( !Shopify.designMode && window.location.href.indexOf('/pages/product-registration') == -1 ) {
		if (region != "") { 
			// If customer has selected a store we might redirect
			storeSelection(region);
		} else if ( geo_incorrect != 'yes' ) {
			//Else Display Store Selector Popup if no store has previously been set
			var request = new XMLHttpRequest();
			request.onreadystatechange = function() {
				if (request.readyState === 4 && request.status === 200) {
					json = JSON.parse(request.responseText)
								
					const current_code = json['location']['country']['code'] 
					let current_country = json['location']['country']['name']
					const language = json['location']['language']['name']
					let traslation = '' 			   
				
					if ( language == 'Dutch' ) {
						traslation = "<p>Welkom bij Olli Ella, Dé plek voor unieke en duurzaam gemaakte producten: van speelgoed tot huis decoratie en damesmode. Ga hier naar de "+store_long+" site. Wilt u uw verzendlocatie wijzigen?</p>";
					} else if ( language == 'French' ) {
						traslation = "<p>L'endroit idéal pour les jouets pour enfants, les articles ménagers et les articles pour femmes fabriqués de manière unique et durable.</p><p>Vous entrez sur notre site "+store_long+"</p><p>Souhaitez-vous modifier votre lieu de livraison?</p>"
					} else if ( language == 'Spanish' ) {
						traslation = "<p>El lugar de juguetes para niños, artículos para el hogar y productos para mujeres hechos de manera única y sostenible.</p><p>Estás ingresando a nuestro sitio "+store_long+"</p><p>¿Le gustaría cambiar su ubicación de envío?</p>"
					}
					if ( traslation != '' ) {
						$('#store-selector-intro').html(traslation);
					}
			
					if (au_countries.indexOf(current_code) >= 0) {
						region = 'au'; 
						current_country = 'Australia'
					} else if (eu_countries.indexOf(current_code) >= 0) {
						region = 'eu';
						current_country = 'Europe'
					} else if (us_countries.indexOf(current_code) >= 0) { 
						region = 'us';
						current_country = 'United States'
					} else if (uk_countries.indexOf(current_code) >= 0) {
						region = 'uk';
						current_country = 'United Kingdom'
					} else {
						region = store_location;
					} 
		
					if ( store_location != region ) {
						setCookie("geo-incorrect", 'yes', 365);
					
						$('#confirm-location').text(current_country)
						$('#confirm-location').data('region',region)
				
	
						$('#store-selector-popup .store-selector.initial').each(function(i, e) {
							regions_found = regions_found + ', ' + $(this).data('region');
						});
				
						$.each(region_list, function(i, location) {
							if (regions_found.indexOf(location) === -1) {
								$('#other-regions [data-region="'+location+'"]').css('display','block');
							}
						});
					
						setTimeout(function () {
							$('#store-selector-popup').fadeIn();
							/*ga('send', 'event', 'Geo Location', 'Popup', 'Shown', { nonInteraction: true });*/
						}, 3000);
					}
				}
			};
			request.open('GET', 'https://api.ipregistry.co/?key=yhowx8s8nkd31k', true);
			request.send(null);
			//setCookie("geo-location-viewed", 'yes', 365);
			//setCookie("location-checked", 'yes', 365);}
		}
	}
});

$('#store-selector-popup .close-popup').click(function() {
	/* ga('send', 'event', { 
		eventCategory: 'Geo Location',
		eventAction: 'Popup',
		eventLabel: 'Closed'
	}); */
	setCookie("geo-location", region, 365);
});

//Newsletter Popup
function newsletterPopup() { 
	if (enable_newsletter) {
		var newsletter_popup = getCookie("newsletter-popup-viewed");
		if (newsletter_popup != "") { 
			//popup viewed so do nothing
		} else {			
			if (getCookie("geo-location") != '') { 
				setTimeout(function(){
					$('#footer-newsletter').addClass('fixed-bottom');
					setCookie("newsletter-popup-viewed", 'yes', 30);
				}, 30000); 
			}
		}
	}
}
 
var promo_popup = getCookie("promo-popup-viewed");
function promoPopup() { 
	setTimeout(function(){
		$('#promo-popup').fadeIn();
		$('#promo-popup').addClass('active');
		
		setTimeout(function(){
			/*ga('send', 'event', 'Marketing', 'Promo Popup', 'Shown', { nonInteraction: true });*/			
			setCookie("promo-popup-viewed", 'yes', 30);	
		}, 1000); 			
	}, 3000); 
}

var cookies_accepted_au = getCookie("cookies-accepted-au");
var cookies_accepted_uk = getCookie("cookies-accepted-uk");
var cookies_accepted = false;

if ( (store_location == 'au') || (store_location == 'us') ) {
	if ( cookies_accepted_au == "yes" ) { 
		var cookies_accepted = true;
	}
} else {
	if ( cookies_accepted_uk == "yes" )  { 
		var cookies_accepted = true;
	}
}

if ( cookies_accepted == true ) { 
	if ( (enable_promo_popup) && (promo_popup == "") && (  window.location.href.indexOf('/collections/cozy-dinkums') == -1 ) ) { 
		promoPopup() 
	} else {
		//currently disabled
		//newsletterPopup()
	}
} else { 
	setTimeout(function(){
		$('#cookies-popup').addClass('fixed-bottom'); 
		if ( (store_location == 'au') || (store_location == 'us') ) {
			setCookie("cookies-accepted-au", 'yes', 365);
		} else {
			setCookie("cookies-accepted-uk", 'yes', 365);
		}							
	}, 5000); 
}

//store location redirect and save cookie	
// Re-add event handler for all matching elements
$('.store-selector').on('click', function(e) {
	e.preventDefault(); 
	
	/*ga('send', 'event', { 
		eventCategory: 'Geo Location',
		eventAction: 'Redirect',
		eventLabel: 'Changed location'
	});*/
	
	region = $(this).data('region');
	setCookie("geo-location", region, 365); 
	storeSelection(region);
});
 
$('#update-location').click(function() {
	/*ga('send', 'event', { 
		eventCategory: 'Geo Location',
		eventAction: 'Popup',
		eventLabel: 'New location Selected'
	});*/
	
	region = $('#new-location select').val();
	setCookie("geo-location", region, 365); 
	storeSelection(region);
}); 

$('#new-location .close-popup').click(function() {
	$('#new-location').fadeOut();
});

$('#select-region a').click(function(e){
	e.preventDefault();
	$('#new-location h5').hide();
	$('#new-location').fadeIn();
});

$('#create-new-account').click(function() {
	/*ga('send', 'event', { 
		eventCategory: 'Marketing',
		eventAction: 'Account Popup Signup',
		eventLabel: 'Newsletter'
	}); */
});

//Copy cart from redirected store
 
/*
$(document).ready(function() {
	if (getCookie("customer-cart") != "") { 
		customer_cart_cookie = JSON.parse(getCookie("customer-cart"));
		//console.log(customer_cart_cookie)
		//First empty cart
		if ( customer_cart_cookie.length != 0 ) {
			ga('send', 'event', { 
				eventCategory: 'Geo Location',
				eventAction: 'Cart',
				eventLabel: 'Migrated'
			});
		
			$.ajax({
				type: "POST",
				url: '/cart/clear.js',
				data: '',
				dataType: 'json',
				success: function() { 
					//console.log('emptying cart')			
					Shopify.moveAlong = function() {
						if (customer_cart_cookie.length) {
							var request = customer_cart_cookie.shift();
							//console.log(request)
							jQuery.getJSON('/products/' + request.handle + '.js', function (product) {
								variant_found = false;
								$.each(product.variants, function(i, variant) {
									if ( variant.title == request.variant ) {
										variant_found = true
										dataObj = {        
											quantity: request.qty, 
											id: variant.id,
										};
										//console.log(dataObj)
										$.ajax({
											type: 'POST',
											url: '/cart/add.js',
											dataType: 'json',
											data: dataObj,
											success: function(res){
												Shopify.moveAlong();
											},
											error: function(error){
												console.log(error);
												console.log("error: " + request);
												Shopify.moveAlong()
											}
										});
									}
								});
								if ( variant_found == false ) {
									//No match? No worries, just move on
									console.log('cant find: '+request.variant)
									Shopify.moveAlong()
								}
							})
							.done(function(product) {
							})
							.fail(function(data) {})
							.always(function(data) {
							});
			

						}
						else {
							document.cookie = 'customer-cart' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; domain=.olliella.com; path=/';
							if ( window.location.pathname == '/cart') {
								location.reload();
							} else {
								ajaxCart.load();
							}
						}
					};
					Shopify.moveAlong();
				}
			});	
		}
	}
});*/
		
$('#join-us').click(function() {
	
	console.log('clicked');
	
	$('#k_id_email').val($('#capture-email').val())
	
	$('#newsletter-popup').fadeIn();
	setCookie("newsletter-popup-viewed", 'yes', 5000);
	
	/*ga('send', 'event', { 
		eventCategory: 'Marketing',
		eventAction: 'Footer Subscribe',
		eventLabel: 'Newsletter'
	}); */
});

//Cookies accepted for 365 days
$('#cookies-popup button').click(function() { 
	$('#cookies-popup').fadeOut();  
}); 
 
$( ".site-nav--has-dropdown" ).hover(function() {
	//$( this ).find('.site-nav__dropdown').css({'height':($($( this ).find(".link-collection-products")).height()+'px')});
});


$('.dropdown-wrapper ul').css('min-height', $('.link-collection-products.first-products').outerHeight()+'px');

//open and close footer links
$('#footer-links h5').click(function() {
	$(this).next('ul').slideToggle();	
});
 
//Close Popup Windows
$('.popup-wrapper .close').click(function() {
	$(this).closest('.popup-wrapper').fadeOut();
});

$(".popup-wrapper").click(function(e) {
	if(e.target !== e.currentTarget) return;
	e.preventDefault();
	$(this).fadeOut();
});

$('#product-delivery').click(function() {
	$('#shipping-popup').fadeIn();
});

$('#size-fit-btn').click(function() {
	$('#size-fit-popup').fadeIn();
	
	//Load all images
	$('#size-fit-popup img').each(function( index ) {
		$(this).attr('src', $(this).data('src'));
	});
});

$('#luggy-size-btn').click(function() {
	$('#luggy-size-popup').fadeIn(); 
});

$('#care-btn').click(function() {
	$('#care-popup').fadeIn();
	
	//Load all images
	$('#care-popup img').each(function( index ) {
		$(this).attr('src', $(this).data('src'));
	});
}); 

$('#care-btn').click(function() {
	$('#care-popup').fadeIn();
	
	//Load all images
	$('#care-popup img').each(function( index ) {
		$(this).attr('src', $(this).data('src'));
	});
}); 

$('#open-newsletter-popup-landing-page').click(function() {
   $('#newsletter-popup').fadeIn();
  
   /*ga('send', 'event', { 
	   eventCategory: 'Marketing',
	   eventAction: 'Opened Landing Page Popup',
	   eventLabel: 'Newsletter'
   }); */
});


$('.close-popup').click(function(){
   $(this).closest('.popup-wrapper').fadeOut();
});


$('#newsletter-popup input[type=checkbox]').click (function () {
   selected_tags = '' 
   $('#newsletter-popup input[type=checkbox]:checked').each(function(i) {
	   selected_tags = selected_tags + $(this).val() + ','
   });
   $('#customer-tags').val(selected_tags)
});

$('#login-instead a').click(function(e){
   e.preventDefault();
   $('#account-create').slideUp();
   $('#account-login').slideDown();
});
  
$('#create-instead').click(function(e){
   e.preventDefault();
   $('#account-login').slideUp();
   $('#account-create').slideDown();
});


$('.trade-terms-btn').click(function(){
  $('#trade-terms-popup').fadeIn(); 
});

$('.close-trade-terms-popup').click(function(){
  $('#trade-terms-popup').fadeOut(); 
});

//Scroll to anchor
$(document).on('click', 'a[href^="#"]', function (event) {
   event.preventDefault();

   $('html, body').animate({
       scrollTop: $($.attr(this, 'href')).offset().top
   }, 1500);
});

const windowHeight = window.innerHeight;
// This function will be executed when the user scrolls the page.
$(window).scroll(function(e) {
	let scroll =  $(this).scrollTop();
	
	// Get the position of the location where the scroller starts.
	var scroller_anchor = $(".scroller_anchor").offset().top;
	
	var nav_height = $('.scroller').outerHeight();
 
 	//console.log(scroller_anchor +' / '+nav_height)
 	
	// Check if the user has scrolled and the current position is after the scroller start location and if its not already fixed at the top 
	if (scroll >= scroller_anchor && $('.scroller').css('position') != 'fixed') {
		// Change the CSS of the scroller to hilight it and fix it at the top of the screen.
		$('.scroller').css({
			'position': 'fixed',
			'top': '0px',
			'width': '100%',
		});
		// Changing the height of the scroller anchor to that of scroller so that there is no change in the overall height of the page.
		$('.scroller_anchor').css('height', nav_height);
		$('#cart-dropdown').addClass('full-height');
	} 
	else if (scroll < scroller_anchor && $('.scroller').css('position') != 'initial') {    // If the user has scrolled back to the location above the scroller anchor place it back into the content.
     
		// Change the height of the scroller anchor to 0 and now we will be adding the scroller back to the content.
		$('.scroller_anchor').css('height', '0px');
     
		// Change the CSS and put it back to its original position.
		$('.scroller').css({
			'position': 'initial' 
		});
		$('#cart-dropdown').removeClass('full-height');
	}
	
	if (document.querySelector('#back-top-top') !== null) {
		if ( scroll > (windowHeight*2) ) {
			$('#back-top-top').addClass('active')
		} else {
			$('#back-top-top').removeClass('active')
		}
	}
}); 

//Autoplay videos
$('.autoplay.all-devices').find('video').trigger('play'); 
if ($(window).width() < 700) {
	$('.autoplay').find('video.large--hide').trigger('play');
} else {
	$('.autoplay').find('video.small--hide').trigger('play');
} 

$('#close-footer-newsletter').click(function() {
	$('#footer-newsletter').removeClass('fixed-bottom');
});

//Move translation select on EU store 
if( $('#gtranslate_wrapper').length ) {
	if ($(window).width() < 700) {
		$('#gtranslate_wrapper').remove().clone().prependTo('.mobile-translate');
	}
};


//*---- HOMEPAGE  ---*//


$('.hp-video-container button.play').click(function(){
	$(this).parent('.hp-video-container').find('video').trigger('play');
	$('.hp-video-container .pause').show();
	$(this).hide();
});

$('.hp-video-container button.pause').click(function(){
	$(this).parent('.hp-video-container').find('video').trigger('pause');
	$('.hp-video-container .play').show();
	$(this).hide();
}); 

setTimeout(function(){
	$('#split-banner-video').find('video').trigger('play');

	if ($(window).width() < 700) {
		$('#homepage-video-mobile').find('video').trigger('play'); 
	} else {
		$('#homepage-video-desktop').find('video').trigger('play');
	} 
}, 1000);

$('.hp-video-container button.sound').click(function(){
	$(this).parent('.hp-video-container').find('video').prop('muted', false); //unmute
	$('.hp-video-container .mute').show();
	$(this).hide();
});

$('.hp-video-container button.mute').click(function(){
	$(this).parent('.hp-video-container').find('video').prop('muted', true); //unmute
	$('.hp-video-container .sound').show();
	$(this).hide();
});

for (let i = 0; i < homepage_sliders.length; i++) {
	let slider = homepage_sliders[i];
	// Do something with the item
	slider = slider.split(':');
	
	$(slider[0]).owlCarousel({
		items:2,
		nav:false,
		autoplay:false,
		dots:true,
		smartSpeed: 500,
		stagePadding: 10, 
		margin: 10,
		loop: false, 
		lazyLoadEager:0,
		autoHeight:true,
		lazyLoad:true, 
		responsive : { 
			// breakpoint from 0 up
			0 : {
			}, 
			// breakpoint from 600 up
			600 : {
			},
			// breakpoint from 990 up
			990 : {
				items:slider[1] 
			}
		}
	});
} 

//*---- PRODUCT PAGE  ---*//


var $owl = $("#product-slideshow");
var owl = $owl.owlCarousel({
	items:1,
	nav:false,
	autoplay:false,
	dots:true,
	autoplaySpeed: 2000,
	smartSpeed: 500,
	loop:true, 
	lazyLoad: true,
	lazyLoadEager: 1,
	autoplayTimeout:5000,
	responsive : { 
		// breakpoint from 0 up
		0 : {
			dots:true,
			nav:false
		},
		// breakpoint from 600 up
		600 : {
			dots:false,
			nav:true
		}
	}		
});


//Product Option Swatches
jQuery(function() {
	jQuery('.product-single .swatch :radio').change(function() {
		var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
		
		var optionValue = jQuery(this).val();
		jQuery(this)
		.closest('form')
		.find('.single-option-selector')
		.eq(optionIndex)
		.val(optionValue)
		.trigger('change');
		
		//console.log( jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val() )
	});
});


$('#product-slideshow').on('click', '.product-video-mob button', function() {
	$(this).parent('.product-video-mob').find('video').trigger('play').css('opacity', '1');
	$(this).fadeOut(); 
});

$('.product-single .swatch :radio').change(function() {
	// we need a 200ms timeout to get the new data values
	setTimeout(swatch_data, 200);
	$(this).closest('.swatch').find('.swatch-element').removeClass('active');
	$(this).parent().addClass('active');   
});


//Add active classes to selected swatches - this could probably be done better
$(".product-single__thumbnails li").removeClass("visible-thumb");
$('.swatch-element').removeClass('active'); 
//on page load only display selected options
$( ".swatch-element" ).each(function( i ) {
	$($(this).children('input:checked')).parent().addClass('active'); 
	var sku = $($(this).children('input:checked')).attr('data-sku');
	if (sku !== '') {
		$("."+sku).addClass("visible-thumb");
	}
});
$('.visible-thumb a').click(); 

//PRODUCT VIDEOS
$('#product-video-thumb').click(function(){
	if($('#ProductPhoto > #product-video').length) {
		//Already a video playing so do nothing
	} else {
		$( "#ProductPhoto" ).append("<video id='product-video' class='product-video always-visible' width='640' height='897' loop poster='{{ product_video_img | img_url: '3x' }}' muted playsinline><source src='"+$(this).data("video")+"'></video>");
		$('#ProductPhotoImg').hide();
		
		setTimeout(function(){
			$('#product-video').trigger('play');
		}, 1000);
		
	}
});

$('.product-single__thumbnail').click(function(){
	if ($('#ProductPhoto > #product-video').length) {
		$('#ProductPhoto #product-video').remove();
		$('#ProductPhotoImg').fadeIn();
	}
}); 

$('#size-fit-popup nav a').click(function(){
	$('.tab-header').removeClass('selected');
	$(this).addClass('selected');
	$('.size-fit-content').hide();
	var selectedTab = '#'+$(this).data("tabcontentid");
	$(selectedTab).show();
});

$('#EnquireHere').click(function(){
	$('#enquiry-popup').fadeIn();

	$('#ContactFormProduct').val($('#product-name h1').html() + ' - ' + $('#product-name h2').html());
	$('#ContactFormQuantity').val($('.js-qty__num').val());
});
   
//$("#related-products-heading").fadeIn();
function recommendationCarousel() {
	
	if (typeof recommendation_loop == 'undefined') {
		recommendation_loop = true
	}
	
	$("#product-recommendations").owlCarousel({
		items:1,
		nav:true,
		autoplay:false,
		dots:true,
		autoplaySpeed: 2000,
		smartSpeed: 500,
		stagePadding: 0, 
		margin: 30,
		loop: false, 
		lazyLoadEager:0,
		autoHeight:true,
		lazyLoad:true, 
		responsive : { 
			// breakpoint from 0 up
			0 : {
				items:1,
				stagePadding: 80,
				margin: 10,
				lazyLoadEager:1,
				dots:true,
				nav:false
			}, 
			// breakpoint from 600 up
			600 : {
				items:2,
				stagePadding: 0,
				dots:true,
				nav:true
			},
			// breakpoint from 990 up
			990 : {
				items:3
			}
		}
	});
}

const handleIntersection = (entries, observer) => {
	if (!entries[0].isIntersecting) return;

	productRecommendationsObserver.unobserve(productRecommendationsSection);

	const url = productRecommendationsSection.dataset.url;
	
	console.log( url )

	fetch(url)
	.then(response => response.text())
	.then(text => {		  
		const html = document.createElement('div');
		html.innerHTML = text;
		const recommendations = html.querySelector('.product-recommendations');

		if (recommendations && recommendations.innerHTML.trim().length) {
			productRecommendationsSection.innerHTML = recommendations.innerHTML;
		}
	})
	.then((complete) => {
		recommendations = $('#related-products').html();
		$('#product-recommendations').append(recommendations);
		$('#related-products').hide();
		recommendationCarousel();
	})

	.catch(e => {
		console.error(e);
	});
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const productRecommendationsObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

if (window.location.href.indexOf('/products/') != -1 && productRecommendationsSection != null) {
	//console.log( productRecommendationsSection )
	productRecommendationsObserver.observe(productRecommendationsSection); 
}

if ($(window).width() < 700) {
	$('#first-image-mob').attr('data-fancybox','images-preview');
} 

//testFunction();


/*=== Accordian menus =====*/
var acc = document.getElementsByClassName("accordion"); 
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

$("#sticky-add-to-cart button").click(function(){
	$('#AddToCart').trigger('click');		
});

swatch_count = 0

function loadJSONProductColorSwatches(data) {
	$.ajax({
		url:	"/collections/all?view=json_swatches",
		type:	'GET'
	})
	.done(function(data) {
		
		console.log( product_key );
		//console.log( title_size );
		//console.log($.parseJSON(data)); 
		$.each(JSON.parse(data).results, function(index, item) {
	  
			if (typeof item.colour !== 'undefined') {
				var current_product = ""
				if( item.colour == product_colour ) {
					current_product = " selected"  
				}
	  
				if (product_key == item.key) {
					console.log( item.key );
					$('#color-swatches').append('<a href="'+item.url+'" data="'+item.colour+'" class="'+item.colour+current_product+' available-'+item.available+'" style="background-image:url('+item.swatch+')"></a>');
					swatch_count = swatch_count + 1
					//console.log('matched');
				} else {
					//console.log('no match');					
				}
			}
		});  
	})
	.fail(function(data) {})
	.always(function(data) {
	});
	
}
if (window.location.href.indexOf('/products/') != -1) {
	if (typeof product_colour !== 'undefined') {
		$(loadJSONProductColorSwatches);	
	}
	
	$(document).ready(function() {
		//Preselect M if available
		const url_params = window.location.search; 
		const m_input = $('.swatch-element input[value="M"]');
		
		if (typeof m_input !== 'undefined' && url_params.indexOf('?variant=') === -1) {
			m_input.trigger('click').trigger('change')
		}
	});
}

//*---- CART PAGE  ---*//
$('#shipping-calculator h4').click(function(){
	$('#calculator-container').slideDown();
}); 

//*---- COLLECTION PAGE  ---*//

//When we hover over product variant selectors change the main image
var sourceSwap = function () {
	var item = $(this);
	$("#" + item.data('id')).attr('src', item.data('src'));
	//console.log("hov: " + item.data('src'));
} 

$('#product-color-selectors img').each(function() { 
}).hover(sourceSwap, sourceSwap); 


// Cloud animations for sold out items and stars animation for preorder items
var specialBadgedProducts = document.querySelectorAll('.js-product-soldout, .js-product-preorder');

// animate clouds on product grid element
function animateBadgeItemsOnScroll(element) {
	ScrollTrigger.create({
		trigger: element,
		start: "top 65%",
		end: "center 25%",
		onEnter: function() {
			element.classList.add('animated');
		},
		onEnterBack: function() {
			element.classList.add('animated');
		},
		onLeave: function() {
			element.classList.remove('animated');
		},
		onLeaveBack: function() {
			element.classList.remove('animated');
		}
	})
}

// in case of touch devices, enable scroll animations
if ($('html').hasClass('supports-touch')) {
	for (var i = 0; i < specialBadgedProducts.length; i++) {
		animateBadgeItemsOnScroll(specialBadgedProducts[i])
	}
} else {
	for (var i = 0; i < specialBadgedProducts.length; i++) {
		specialBadgedProducts[i].addEventListener('mouseenter', function(event) {
			event.target.classList.add('animated');
		})

		specialBadgedProducts[i].addEventListener('mouseleave', function(event) {
			event.target.classList.remove('animated');
		})
	}
}

if (document.querySelector('.section-block-image-scroller') !== null) {
	setTimeout(function(){
		//make sure page has loaded sufficiently
		$('.section-block-image-scroller').each(function() {
			scroller_height = $(this).find('.images').outerHeight()
			if ($(window).width() > 1059) {
				$(this).find('.column').css('height', scroller_height+'px')
				$(this).css('height', scroller_height+'px')
			} else {
				$(this).find('.column.img-col').css('height', scroller_height+'px')
			}					
		}); 
	}, 2000);
}


function check_gwp(cart){
	//console.log(cart)
	let gwp_in_cart = false;
	let gwp_cart_min = 13000;
	if ( store_location == 'us' ) {
		gwp_cart_min = 11000;
	} else if ( store_location == 'eu' ) {
		gwp_cart_min = 10000;
	} else if ( store_location == 'uk' ) {
		gwp_cart_min = 7000;
	}

	$.each(cart.items, function(i, product) {
		if (gwp_products.indexOf(product.handle) > -1) {
			gwp_in_cart = true;
		}
	}); 
	
	if ( (!gwp_in_cart) && (cart.total_price > gwp_cart_min) ) {
		if ( getCookie("seen-gwp") != 'yes' ) {
			$('#gwp-popup').fadeIn();
			setCookie('seen-gwp', 'yes', 0.1);
		} else {
			$('#gwp-trigger').addClass('active');
		}
	}
}

function gwp(){
	if (enable_gwp) {		
		fetch(window.Shopify.routes.root + 'cart.js')
		.then(response => response.json())
		.then(data => check_gwp(data) );
	}
}

$('#gwp-trigger').click(function(){
	$('#gwp-popup').fadeIn();
	$(this).removeClass('active');
});

gwp();

/*===== COLLECTION DATA =====*/

var collection_data = null

if ($('.collection-grid')[0]){
	$.ajax({
		url: '/collections/'+$('.collection-grid').data('handle')+'?view=json',
		type: 'GET'
	})
	.done(function(data) {
		
		//console.log(JSON.parse(data).results)
		
		collection_data = data
	})
	.fail(function(data) {})
    .always(function(data) {
        $(loadCollectionFilters(data));
    });
}


function AddProduct(product,SelectedSizes) {	
	//Create the product object
	product_classes = 'grid__item large--one-third medium--one-half collection-product text-center available-'+product.available;

	var $Product = $("<div>", {"class": product_classes});
	var $ProductInfo = $("<div>", {"class": "info-container"});

	var $img = $("<a>", {"class": "grid__image", "href": product.url});
	
	img_1 = '<img loading="lazy" src="'+product.firstImage+'"/>';
	img_2 = '<img loading="lazy" class="hidden" src="'+product.secondImage+'"/>';
	 
	let 
		discountPercentFlag = '',
		collectionLabelFlag = '',
		flag_count = 0,
		secondaryFlagClass = '';
		
	console.log(product.discountPercent)
	if (product.discountPercent != '0') {
		discountPercentFlag = '<div class="product-flag sale-percent-flag">' + product.discountPercent + '% OFF</div>'
		flag_count = 1
	}
	
	if (label_tag_1 || label_collection_1 != collection_handle) {
		if (product.tags.includes(label_tag_1)) {
			if ( flag_count == 1 ) {
				secondaryFlagClass = ' secondary-flag'
			}
			collectionLabelFlag = '<div class="product-flag collection-label'+secondaryFlagClass+'">' + label_text_1 + '</div>'
		}
	}
	
	product_title = product.title
	title_parts = product_title.split(' - ')
	product_colour = ''
	product_title = title_parts[0]
	if ( title_parts.length == 2) {
		product_colour = title_parts[1]
	} else if ( title_parts.length == 3) {
		product_colour = title_parts[2]	
		product_title = product_title + ' ' + title_parts[1]
	}
			
	$img.append(img_1 + img_2 + discountPercentFlag + collectionLabelFlag)

	title = '<h4><a class="product-title" href="' + product.url + '"><span>' + product_title + '</span><span class="subtitle">'+product_colour+'</span></a></h4>';
	
	var $ProductPrice = $("<h6>", {"class": "product-price"});
	var $ProductSalePrice = $("<s>", {"class": "product-price on-sale"});

	$ProductPrice.append(Shopify.formatMoney(product.price));

	if (product.compare_at_price !== undefined) {
		if (parseInt(product.price) < parseInt(product.compare_at_price)) {
			$ProductPrice.addClass('on-sale')
		
			$ProductSalePrice.append(Shopify.formatMoney(product.compare_at_price));
			$ProductPrice.append($ProductSalePrice);
		} else { 
		}
	} 
		
	if (product.type == 'bundle') {
		var $ProductForm = $("<div>"); 
		var cta_button = '<a href="'+product.url+'" class="btn">View Bundle</a>'
		$ProductForm.append(cta_button)
	} else {
		var $ProductForm = $("<form>", {"class": "AddToCartForm", "method": "post", "action": "/cart/add"});
		
		if (product.type != 'nursing chairs') {
			if ( product.variants.length == 1 ){ 
				variant = product.variants[0]
			
				var_input = '<input type="hidden" name="id" value="'+variant.id+'" />'
				var cta_button = '<input type="submit" value="Add To Bag" class="btn AddToCart bnt-e" />'
			
				if ( variant.available != true ) {
					cta_button = '<input type="submit" value="Sold Out" class="btn bnt-b" disabled />'
				}
									
				if (product.inventory_management == 'continue' && product.inventory < 1 ) {
					cta_button = '<a href="{{ product.url | within: collection }}" class="btn bnt-c">Pre-order</a>'
				}
			
				$ProductForm.append(var_input, cta_button)
			
			} else {
						
				var $select = $("<select>", {"name": "id"});
				var cta_button = '<input type="submit" value="Add To Bag" class="btn AddToCart bnt-a" />'
			
				$(product.variants).each(function (i, variant) {
					let variant_title = variant.title
					if (variant_title.indexOf(' / ') > -1) {
						variant_title = variant_title.split(' / ')[1]
					}
					
					if (variant.available){		
						selected_variant = '';
						
						if ( SelectedSizes[0] == variant_title.toLowerCase() ) {
							selected_variant = ' selected'
						} 
						$select.append('<option data-sku="'+variant.sku+'" value="'+variant.id+'"'+selected_variant+'>'+variant_title+'</option>')
					} else {
						$select.append('<option disabled="disabled">'+variant_title+' - Sold Out</option>');
					}
				});
			
				if (( product.inventory_management == 'continue' ) && ( product.inventory < 1 )) {
					cta_button = '<a href="{{ product.url | within: collection }}" class="btn bnt-c">Pre-order</a>'
				}
			
				$ProductForm.append($select, cta_button)
			}		
		}
	}

		 
	$ProductInfo.append(title,$ProductPrice)
	
	$Product.append($img,$ProductInfo,$ProductForm)
	
	$('.collection-grid').append($Product) 
	bold_copyright();
} 


/*===== COLLECTION FILTERS =====*/
var filtersLoaded = false 

function convert_val(value){
	item_val = value.toLowerCase().replace(' &','').replace(/'/g,'').replace(/ /g,'-');
}

function loadCollectionFilters(collection_data) {
	
	FiltersType = []
	FiltersSizes = []
	FiltersAges = []
	FiltersColours = []
	FiltersMaterials = []
	FiltersFunctions = []
	  
	$.each(JSON.parse(collection_data).results, function(index, item) {
		if( filtersLoaded == false ) {
				
			if (item.type !== undefined && item.type !== '') {
				FiltersType.push(item.type); 
			}		
			
			if (item.ages !== undefined && item.ages !== '') {
				ages = item.ages
				ages = ages.split(',');
				$.each(ages, function(key, age) {
					if ( age !== '' ) {
						FiltersAges.push(age);
					} 
				}); 
			}
			
			if (item.sizes) {
				$.each(item.variants, function(i, variant) {
					if (variant.available) {
						let variant_size = variant.title
						if (variant_size.indexOf(' / ') > -1) {
							variant_size = variant_size.split(' / ')[1]
						}
						if ( (variant_size !== undefined && variant_size !== 'EA' && variant_size !== 'Default') ) {
							if (variant_size.indexOf('/') > -1) {
								//Some variants are s/m or m/l so we need to split to include both
								variant_size_split = variant_size.split('/');
								$.each(variant_size_split, function(i, item) {
									FiltersSizes.push(item);
								});
							} else {
								FiltersSizes.push(variant_size);
							}
						}
					}
				}); 
			}
									
			if (item.colours !== undefined && item.colours !== '') {								
				colours = item.colours
				colours = colours.split(',');
				$.each(colours, function(key, colour) {
					if ( colour !== '' ) {
						FiltersColours.push(colour);
					} 
				}); 
			}
			
			if (item.material !== undefined && item.material !== '') {
				FiltersMaterials.push(item.material); 
			}	
			
			functions = item.functions
			if (functions !== undefined && functions !== '') {
				functions = functions.split(',');
				$.each(functions, function(key, value) {
					if ( value !== '' ) {
						FiltersFunctions.push(value);
					} 
				}); 
			}
			
			if (item.discountFilterIndex !== undefined && item.discountFilterIndex !== '') {
				$('#discount-'+item.discountFilterIndex).closest('li').show();
			}
		}
	}); 
				
	if (filtersLoaded == false ) {
		if (typeof categories_found !== 'undefined' && categories_found == false) {
			FiltersType = FiltersType.filter(function(elem, index, self) {
				return index === self.indexOf(elem);
			});
		
			$.each(FiltersType, function(key, type) {
				convert_val(type)
				//Doll Accessory
				//console.log(item.title);
								
				$('#li-type-'+item_val).show();
			});
		}
			
		FiltersAges = FiltersAges.filter(function(elem, index, self) {
			return index === self.indexOf(elem);
		});
		if ( FiltersAges.length == 0 ) {
			$('#collection-ages').hide()
		} else {
			var ordering = {}, // map for efficient lookup of sortIndex
			sortOrder = ['0-1-year', '1-year', '2-years', '3-years', '4-years', '5-years', '6+-years']
			for (var i=0; i<sortOrder.length; i++)
				ordering[sortOrder[i]] = i; 
		
			FiltersAges.sort( function(a, b) {
				//console.log('first: '+a)
				//console.log('second: '+b)
				return (ordering[a] - ordering[b]) || a.localeCompare(b);
			}); 
				
			$.each(FiltersAges, function(key, type) {
				convert_val(type)
				$('#collection-ages ul').append('<li><input type="checkbox" id="filter-type-'+item_val+'" name="filter-type-'+item_val+'" value="'+item_val+'"><label for="filter-type-'+item_val+'">'+type.replace('0 1','0-1')+'</label></li>')
			});
		}

		FiltersSizes = FiltersSizes.filter(function(elem, index, self) {
			return index === self.indexOf(elem);
		});		
		if ( FiltersSizes.length < 2 ) {
			$('#collection-sizes').hide()
		} else {
			var ordering = {}, // map for efficient lookup of sortIndex
			sortOrder = ['Default','35','36','37','38','39','40','41','42','OS','XXS','XS','S','S/M','SM','M','M/L','ML','L','XL','XL']
			for (var i=0; i<sortOrder.length; i++)
				ordering[sortOrder[i]] = i; 
		
			FiltersSizes.sort( function(a, b) {
				return (ordering[a] - ordering[b]) || a.localeCompare(b);
			}); 
				
			$.each(FiltersSizes, function(key, type) {
				convert_val(type)
				$('#collection-sizes ul').append('<li><input type="checkbox" id="filter-type-'+item_val+'" name="filter-type-'+item_val+'" value="'+item_val+'"><label for="filter-type-'+item_val+'">'+type+'</label></li>')
			});
		}
	
		FiltersColours = FiltersColours.filter(function(elem, index, self) {
			return index === self.indexOf(elem);
		});
		if ( FiltersColours.length < 2 ) {
			$('#collection-colours').hide()
		} else {
			$.each(FiltersColours, function(key, type) {
				convert_val(type)
				$('#collection-colours ul').append('<li><input type="checkbox" id="filter-type-'+item_val+'" name="filter-type-'+item_val+'" value="'+item_val+'"><label for="filter-type-'+item_val+'">'+type+'</label></li>')
			});
		}
		
		FiltersMaterials = FiltersMaterials.filter(function(elem, index, self) {
			return index === self.indexOf(elem);
		});
		if ( FiltersMaterials.length < 2 ) {
			$('#collection-materials').hide()
		} else {		
			$.each(FiltersMaterials, function(key, type) {
				convert_val(type)
				$('#collection-materials ul').append('<li><input type="checkbox" id="filter-type-'+item_val+'" name="filter-type-'+item_val+'" value="'+item_val+'"><label for="filter-type-'+item_val+'">'+type.replace('-', ' ')+'</label></li>')
			});
		}
		
		FiltersFunctions = FiltersFunctions.filter(function(elem, index, self) {
			return index === self.indexOf(elem);
		});
		if ( FiltersFunctions.length < 2 ) {
			$('#collection-function').hide()
		} else {		
			$.each(FiltersFunctions, function(key, type) {
				convert_val(type)
				$('#collection-function ul').append('<li><input type="checkbox" id="filter-type-'+item_val+'" name="filter-type-'+item_val+'" value="'+item_val+'"><label for="filter-type-'+item_val+'">'+type.replace('-', ' ')+'</label></li>')
			});
		}
		
		filtersLoaded = true
	}
	
	//Preselect a filter with a ?filter=X url parameter
	var url_params = window.location.search; 	
	if (url_params.indexOf('?filter') != -1) {
		filter_val = url_params.split('?filter=')[1]
		$('#collection-filters input[value="'+filter_val+'"]').trigger('click');
	} 
} 

function filterCollection(collection_url){	
    $('.pagination').hide();
    $('.collection-grid').empty();
    
    $('.collection-grid').before('<div class="loading-collection"><span class="loader delay-2"></span> <span class="loader delay-1"></span> <span class="loader"></span></div>');
    
    SelectedTypes = [];
    SelectedSizes = [];
    SelectedAges = [];
    SelectedColours = [];
    SelectedMaterials = [];
    SelectedFunctions = [];
    SelectedPrices = [];
    SelectedDiscounts = [];

    $('#collection-types input:checked').each(function() {
        SelectedTypes.push($(this).val());
    });

    $('#collection-sizes input:checked').each(function() {
        SelectedSizes.push($(this).val());
    });

    $('#collection-ages input:checked').each(function() {
        SelectedAges.push($(this).val());
    });

    $('#collection-colours input:checked').each(function() {
        SelectedColours.push($(this).val());
    });

    $('#collection-materials input:checked').each(function() {
        SelectedMaterials.push($(this).val());
    });

    $('#collection-prices input:checked').each(function() {
        SelectedPrices.push(parseInt($(this).val()));
    });

    $('#collection-discounts input:checked').each(function() {
        SelectedDiscounts.push(parseInt($(this).val()));
    });

    $('#collection-function input:checked').each(function() {
        SelectedFunctions.push($(this).val());
    });

    let SelectedSort = $('#collection-sort select').val();
    let sortParam = SelectedSort ? `&sort_by=${SelectedSort}` : "";

    $.ajax({
        url: `/collections/${collection_url}?view=json${sortParam}`,
        type: 'GET'
    })
    .done(function(data) {
        $('.loading-collection').remove();
        $('.product-grid').not(':first').remove();
        $('#products-grid').empty();

        $.each(JSON.parse(data).results, function(index, item) {
            let match = typeof item.title !== 'undefined';

            if (SelectedTypes.length !== 0 && match) {
                match = typeof item.type !== 'undefined' && SelectedTypes.includes(item.type_handle);
            }

            if (SelectedSizes.length !== 0 && match && item.sizes) {
                match = false;
                $.each(item.variants, function(i, variant) {
                    if (variant.available) {
                        let variant_size = variant.title.includes(' / ') ? variant.title.split(' / ')[1] : variant.title;
                        if (variant_size.includes('/')) {
                            variant_size.split('/').forEach(size => {
                                convert_val(size);
                                if (SelectedSizes.includes(item_val)) {
                                    match = true;
                                }
                            });
                        } else {
                            convert_val(variant_size);
                            if (SelectedSizes.includes(item_val)) {
                                match = true;
                            }
                        }
                    }
                });
            }

            if (SelectedAges.length !== 0 && match && typeof item.ages !== 'undefined') {
                match = false;
                convert_val(item.ages);
                let productAges = item_val.split(',');
                match = SelectedAges.some(v => productAges.includes(v));
            }

            if (SelectedColours.length !== 0 && match && typeof item.colours !== 'undefined') {
                match = false;
                let productColour = item.colours.split(',');
                match = SelectedColours.some(v => productColour.includes(v));
            }

            if (SelectedMaterials.length !== 0 && match && typeof item.material !== 'undefined') {
                match = false;
                convert_val(item.material);
                match = SelectedMaterials.includes(item_val);
            }

            if (SelectedFunctions.length !== 0 && match) {
                if (typeof item.function !== 'undefined') {
                    match = false;
                    convert_val(item.function);
                    match = SelectedFunctions.includes(item_val);
                }
                if (typeof item.functions !== 'undefined') {
                    match = false;
                    convert_val(item.functions);
                    let productFunctions = item_val.split(',');
                    match = SelectedFunctions.some(v => productFunctions.includes(v));
                }
            }

            if (SelectedPrices.length !== 0 && match && typeof item.priceFilterIndex !== 'undefined') {
                match = SelectedPrices.includes(item.priceFilterIndex);
            }

            if (SelectedDiscounts.length !== 0 && match && typeof item.discountFilterIndex !== 'undefined') {
                match = SelectedDiscounts.includes(item.discountFilterIndex);
            }

            // Exclude "Coming Soon" products
if (match == true) {
    if (item.tags && item.tags.includes("coming-soon")) {
        match = false;  // Exclude product
    }
}

// If still matched, add the product
if (match == true) {
    AddProduct(item, SelectedSizes);
}
        });

        $('.collection-product.available-false').each(function() {
            $(this).appendTo('.collection-grid');
        });
    });

    /*
    SecondImageRollovers.initRollovers();
    $(loadCollectionSwatches(collection_url));
    QuickView();
    currency_convertor();
    */
}

$(document).on("change", "#collection-filters input, #collection-sort select, #gift-selector input", function () {
    filterCollection($('.collection-grid').data('handle'));
});


$(document).on("change", "#gift-selector input", function () {
	$('#sort-tigger .text').html( $(this).next('label').html() )
});


$('#gift-selector button').click(function(){
	$('#gift-selector ul').toggleClass('open')
});

$(document).on("change", "#gift-selector input", function () {
	$('#gift-selector ul').removeClass('open')
});

$('.filter--active').each(function(i) {
	$(this).closest('ul').addClass('open');
	$(this).closest('ul').prev('h5').addClass('open');
});
  
$('#apply-filters').click(function(){
	$('#collection-filters').removeClass('open');
});

$('#clear-filters').click(function(){
	$('#collection-filters input:checkbox').removeAttr('checked');
	$(filterCollection(collection_data));
});

$('#filter-trigger').click(function(){
	$('#collection-filters').toggleClass('open');
});


$('#collection-filters h5').click(function(){
	$(this).toggleClass('open');
	$(this).next('ul').toggleClass('open');
}); 
 
function not_searching() {
	$('#popluar-searches, .search-recomendations, .search-results').show();
	$('#no-results, .search-results').hide();
}

$(function ajax_search() {
	// Grabbing all search forms on the page, and adding a .search-results list to each.
	var searchForms = $('#search-drawer form[action="/search"]').each(function() {
		// Grabbing text input.
		var input = $(this).find('input[name="q"]');
		// Adding a list for showing search results.
		var offSet = input.innerHeight();
		$('<ul class="search-results"></ul>').appendTo($(this)).hide(); 	   
		// Listening to keyup and change on the text field within these search forms.
		
		function delay(callback, ms) {
		  var timer = 0;
		  return function() {
		    var context = this, args = arguments;
		    clearTimeout(timer);
		    timer = setTimeout(function () {
		      callback.apply(context, args);
		    }, ms || 0);
		  };
		}
		
		input.attr('autocomplete', 'off').bind('keyup change', delay(function (e) {		
			
			// What's the search term?
			var term = $(this).val(); 
			// What's the search form?
			var form = $(this).closest('form'); 
			
			var searchURL = "/search/suggest.json?q="+term+"&resources[type]=product&resources[options][unavailable_products]=show&resources[limit]=9&resources[options][fields]=title,product_type,body,variants.title"
			var resultsList = form.find('.search-results');
			
			if (term.length > 2 && term != $(this).attr('data-old-term')) {
				$('#searching-animation').show();
				$(this).attr('data-old-term', term);
				
				fetch(searchURL)
					.then((response) => response.json())
					.then((suggestions) => {
						$('#searching-animation').hide();
						resultsList.empty();
						const productSuggestions = suggestions.resources.results.products;

						if (productSuggestions.length == 0) {
							resultsList.hide();
							//Search status messages
							$('#no-results, .search-recomendations, #popluar-searches').show();
							$('.search-results, .results-heading').hide();
							
						} else {
							$('.search-results, .results-heading').show();
							$('#no-results, .search-recomendations, #popluar-searches').hide();
							
							const firstProductSuggestion = productSuggestions[0];
							console.log(productSuggestions)
							
							//$('#searching-animation').fadeOut('fast');
							$('.results-heading').slideDown('fast');
							$('#no-results').slideUp('fast');
		  
							//Add a nice heading
							resultsList.append('<li class="results-heading"><h4>Top Results</h4></li>');    
		  							
							$.each(productSuggestions, function(index, item) {
								if ( $.isEmptyObject(item) || item.price == 0 ) { 
									// If product is empty skip
									// Use this to hide soldout items:
									//( ($.isEmptyObject(item)) || (item.availability == 'soldout' ))									
								} else { 
									//console.log('found: '+item.title)
									item_title = item.title;
									item_title = item_title.replace('—','-');
								
									//Hide astrixed products for 2022 secret wholesale duplicate products
									if (item_title.indexOf('*') === -1) {
										var link = $('<a></a>').attr('href', item.url);
										link.append('<div class="thumbnail"><img src="' + item.image + '" /></div>');
										link.append('<p class="title">' + item_title + '</p>');
										link.wrap('<li></li>');
										resultsList.append(link.parent());	
									}			  
								}
							});
		  
							if (productSuggestions.length == 9) {
								resultsList.append('<li class="view-all-results"><a href="/search?q=' + term + '">View all results</a></li>');
							};
							resultsList.fadeIn(200);
							
						}
					}
				);
			} else {
				if ( term != $(this).attr('data-old-term')) {
					$('.search-recomendations, #popluar-searches').show();
					$('#no-results, .search-results, .results-heading').hide();
				}
			} 
		}, 1000));
	});
});

searchInput = $('#search-drawer input[type="search"]');

//search by popular search term
$('#popluar-searches li').click(function(e) {
	e.preventDefault();
	var search_term = $(this).html();
	searchInput.val(search_term).trigger('change');
});

$('.search-trigger').click(function(e){
	e.preventDefault();
	$('#search-drawer').addClass('open');
	//focus on inpout and remove default saved value so we get the nice 'Search our store...' text
	searchInput.focus().val("");
});

$('.close-search').click(function(){
	$('#search-drawer').removeClass('open');
});



$('.section-video button.play').click(function(){
	$(this).parent('.section-video').find('video').trigger('play');
	$('.section-video .pause').show();
	$(this).hide();
});

$('.section-video button.pause').click(function(){
	$(this).parent('.section-video').find('video').trigger('pause');
	$('.section-video .play').show();
	$(this).hide();
}); 

$('.section-video button.sound').click(function(){
	$(this).parent('.section-video').find('video').prop('muted', false); //unmute
	$('.section-video .mute').show();
	$(this).hide();
});

$('.section-video button.mute').click(function(){
	$(this).parent('.section-video').find('video').prop('muted', true); //unmute
	$('.section-video .sound').show();
	$(this).hide();
});




$('#makers-map button').click(function(){		
	$('.maker-popup[data-maker="'+$(this).data('maker')+'"]').fadeIn();
});

if ($(window).width() < 700) {
	$('#makers-map').scrollLeft(650).scrollTop(100)
}


$('#size-fit-popup input').change(function(){
	var unit = 'in'
	
	if ( $(this).val() == 'in' ) {
		var unit = 'in'
		$('#size-fit-popup input[value="in"]').prop( "checked", true );
	} else {
		var unit = 'cm'	
		$('#size-fit-popup input[value="cm"]').prop( "checked", true );
	}
		
	$('#size-fit-popup table:not(.no-conversion) td').each(function() {
		var numbers = /^[0-9]/; 
		var td = $(this).html()
		
		//only convert td with numbers
		if ( numbers.test( td ) ) {
			if ( td.includes(' - ') ) {
					
				td =  td.split(' - ')
				
				new_td = ''
								
				$.each(td , function( index, td ) {
					if ( unit == 'in' ) {
						td_val = td * 0.39370
						td_val = td_val.toFixed(1)
					} else {
						td_val = td / 0.39370
						td_val = td_val.toFixed(0)
					}
					
					new_td = new_td + ' - ' + td_val
				});
				
				$(this).html(new_td.replace(' - ',''))
				
			} else {
				if ( unit == 'in' ) {
					td_val = td * 0.39370
					td_val = td_val.toFixed(1)
				} else {
					td_val = td / 0.39370
					td_val = td_val.toFixed(0)
				}
				
				$(this).html(td_val)
				
			}
		}		
	});
})


function throttle(fn, wait) {
	var time = Date.now();
	return function() {
		if ((time + wait - Date.now()) < 0) {
			fn();
			time = Date.now();
		}
	}
}

$('#cart-dropdown').on('click', '.remove', function() {
	var mini_cart_item = $(this).closest('.mini-cart-item');
	var remove_btn = $(this)
	var product_var_id = mini_cart_item.data('id');
	var product_var_qty = remove_btn.data('qty') - 1;
		
	$.ajax({
		url: '/cart/change.js', 
		dataType: 'json',
		type: 'post',
		data: {
			quantity: product_var_qty, 
			id: product_var_id
		}, 
		success: function(itemData) { 
			//cart_count = $('#cart-button .CartCount').html();
			//console.log(cart_count)		
			
			//console.log(itemData)
			
			$('.CartCount').text( itemData.item_count )
			$('#CartPrice').text( Shopify.formatMoney( itemData.total_price) ) 
	
			if ( product_var_qty > 0 ) {
				mini_cart_item.find('.item-qty').text(product_var_qty)
				remove_btn.data('qty',product_var_qty)
			} else {
				mini_cart_item.next('hr').remove()
				mini_cart_item.remove()
			}
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
		}
	});
});

$('#CartContainer').on('click', '.AddToCart', function(e) {
	e.preventDefault();
	
	var clicked_btn = $(this)
	var selected_id = $(this).prev('input').val()
	
	//console.log( selected_id )
	
	$.ajax({
		url: '/cart/add.js', 
		dataType: 'json',
		type: 'post',
		data: {
			quantity: 1, 
			id: selected_id
		}, 
		success: function(itemData) { 
			clicked_btn.val('added').prop('disabled', true);
			update_cart_drawer();
			update_mini_cart();
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
		}
	});
});

function update_cart_count(cart){
	//console.log( cart)
	$('.CartCount').text(cart.item_count)
	console.log( Shopify.formatMoney );
	$('#CartPrice').html( Shopify.formatMoney(cart.total_price) );
} 

function update_mini_cart(){	
	fetch('/cart/?sections=template--cart')
	.then(response => response.text())
	.then(html => {
		//console.log(JSON.parse(html))
		parsedHTML = JSON.parse(html)
		//console.log('new cart:')
		var cart_section = 'template--cart'
		const parsedCart = parsedHTML[cart_section]
		var parser = new DOMParser();
		var cartHTML = parser.parseFromString(parsedCart, 'text/html');
		
		// Select the element with the id "gift-options-cart"
		const
		cart_form = cartHTML.querySelector('form'),
		cart_dropdown = document.getElementById("cart-dropdown"),
		giftOptionsCart = cartHTML.getElementById("gift-options-cart"),
		ShippingCalcCart = cartHTML.getElementById("shipping-calculator");
		CartUpsells = cartHTML.getElementById("cart-upsells");


		// If the element exists, remove the id attribute
		if (giftOptionsCart) {
		    giftOptionsCart.parentNode.removeChild(giftOptionsCart);
		}
		if (ShippingCalcCart) {
		    ShippingCalcCart.parentNode.removeChild(ShippingCalcCart);
		}
		if (CartUpsells) {
		    CartUpsells.parentNode.removeChild(CartUpsells);
		}

		//console.log( cart_form )
		cart_dropdown.innerHTML = "";
		if ( cart_form == null) {
			cart_dropdown.innerHTML = `
			<div id="empty-cart">
				<h5>Empty Cart</h5>
				<p>Your cart has no products in it</p>
			</div>`
		} else {
			cart_dropdown.appendChild(cart_form);
		}
	})
	.catch(e => {
		console.error(e);
	});
	
	/*
	
	//Remove existing item in minicart items
	$('.mini-cart-item').each(function() {
		$(this).next('hr').remove()
		$(this).remove()
	});

	$('#empty-cart').remove();
	$('#cart-dropdown .buttons').show();
	
	settings = {
		moneyFormat:'${{amount}}'
	};
	
	//Add new product to the header minicart
	$(cart.items).each(function(i, product) {
						
		var $Product = $("<div>", {"class": "mini-cart-item grid text-left", "data-id": product.variant_id });
		var $ProductInfo = $("<div>", {"class": "grid__item six-twelfths"});

		var item_qty = product.quantity 

		var img = '<div class="grid__item three-twelfths"><img src="'+ product.image +'"/></div>';
		var title = '<a href="' + product.url + '" class="h6">' + product.title + '</a>';
		var qty = '<div class="cart-product-details"><p>Quantity: <span class="item-qty">' + item_qty + '</span></p></div>';
		var subtotal = '<div class="grid__item three-twelfths text-right"><p>'+ Shopify.formatMoney(product.price, settings.moneyFormat) + '</p><p><button type="button" class="remove" data-qty="'+item_qty+'" data-id="'+product.variant_id+'"><img src="https://cdn.shopify.com/s/files/1/0002/0820/7925/t/85/assets/icon-bin_40x.png"/></button></p></div>';  
		var hr = '<hr/>';  

		$ProductInfo.append(title,qty)

		$Product.append(img, $ProductInfo,subtotal)

		$('#cart-dropdown form').prepend($Product,hr) 
		
		if (product.handle == 'gift-card') {
			contains_gift_card = true;
		}
	});
	
	$('.CartCount').html(cart.item_count).removeClass('hidden-count');

	if (cart.item_count === 0) {
		$('.CartCount').addClass('hidden-count');
	}
	$('#CartPrice').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
	*/
}

function lucky_dip_promo(checkout_total,cartRows){

	if ( checkout_total > lucky_dip_threshold) {
		
		let has_luckdip = false

		cartRows.forEach(function(cartRow) {
			//console.log( cartRow )
			var h4Element = cartRow.querySelector('.h4');
			//
	
			if (h4Element && h4Element.textContent.includes('Lucky Dip')) {
				console.log( h4Element.textContent )
				has_luckdip = true
			}
		});		
	
		if ( has_luckdip == false ) {
			const lucky_dip_popup = document.getElementById("lucky-dip-popup");
			if ( lucky_dip_popup ) {
				lucky_dip_popup.style.display = "block";
		
				const
				luckyImgPlaceholder = document.getElementById('lucky-animation-placeholder'),
				luckyImgContainer = document.getElementById('lucky-img-animation'),
		    	luckyImages = luckyImgContainer.querySelectorAll('img'),
		    	luckyDipBtn = document.getElementById('lucky-dip-pick');
				
				luckyImages.forEach(function(image) {
					image.src = image.dataset.src;
				});
	
				luckyDipBtn.addEventListener('click', () => {
					luckyImgPlaceholder.style.display = "none";
					luckyImgContainer.style.display = "block";
					
					luckyDipBtn.disabled = true;
					luckyDipBtn.textContent = 'Picking prize...';
					
					
					setTimeout(function () {
						fetch('/cart/add.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								id: luckyDipBtn.dataset.id,
								quantity: 1 
							})
						})
						.then(response => { 
							console.log('Variant added to cart!');
							update_cart_drawer();
							lucky_dip_popup.style.display = "none";
							
							//reset popup
							luckyImgPlaceholder.style.display = "block";
							luckyImgContainer.style.display = "none";
					
							luckyDipBtn.disabled = false;
							luckyDipBtn.textContent = 'ADD MYSTERY GIFT'; 
						})
						.catch(error => {
							console.error('Error adding to cart:', error);
						});
					}, 2000);
					
				});
			}
		}
	} else { 
		cartRows.forEach(function(cartRow) {
			//console.log( cartRow )
			var h4Element = cartRow.querySelector('.h4');
			//
		
			if (h4Element && h4Element.textContent.includes('Lucky Dip')) {
				cartRow.querySelector('.cart__remove').click();
			}
		});
	}
}

function update_cart_drawer(){
	
	$('#cart-loader span').addClass('loading');
	
	fetch('/cart/?sections=template--cart')
	.then(response => response.text())
	.then(html => {
		//console.log(JSON.parse(html))
		parsedHTML = JSON.parse(html)
		//console.log('new cart:')
		var cart_section = 'template--cart'
		const parsedCart = parsedHTML[cart_section]
		var parser = new DOMParser();
		var cartHTML = parser.parseFromString(parsedCart, 'text/html');
		
		const
		cart_form = cartHTML.querySelector('form'),
		cart_title = cartHTML.getElementById('cart-title'),
		ShippingCalcCart = cartHTML.getElementById("shipping-calculator"),
		cart_footer = cartHTML.querySelector('.cart-page-footer'),
		checkout_value = cartHTML.querySelector('.checkout-value'),
		drawer_cart_title = document.getElementById("drawer-cart-title"),
		drawer_checkout_value = document.querySelector(".checkout-value"),
		cart_container = document.getElementById("CartContainer"),
		cartRows = cartHTML.querySelectorAll('.cart__row');
			
		if (ShippingCalcCart) {
		    ShippingCalcCart.parentNode.removeChild(ShippingCalcCart);
		}
		if (cart_footer) {
		    cart_footer.parentNode.removeChild(cart_footer);
		}
				
		cart_container.innerHTML = "";
		
		if ( cart_form == null) {
			cart_container.innerHTML = `
			<div id="empty-cart">
			<h5>Empty Cart</h5>
			<p>Your cart has no products in it</p>
			</div>`
		} else {
			cart_container.appendChild(cart_form);
			drawer_checkout_value.innerHTML = checkout_value.innerHTML
			drawer_cart_title.innerHTML = cart_title.innerHTML
			
			//console.log( cart_form.dataset.lastProduct );
			
			const url = '/products/dinkum-dolls-pea/recommendations/products?section_id=related-products&product_id='+cart_form.dataset.lastProduct+'&limit=3';
	  	  	const url_hard = '/recommendations/products?section_id=related-products&product_id='+cart_form.dataset.lastProduct+'&limit=6'
			
			$('.cart-recommendations').addClass('loaded');
			fetch(url_hard)
			.then(response => response.text())
			.then(text => {		  
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations');

				console.log( recommendations )

				if (recommendations && recommendations.innerHTML.trim().length) {
					//productRecommendationsSection.innerHTML = recommendations.innerHTML;
					
					const CartReccomendationsMobile = document.querySelector('#CartReccomendations-Mobile');
					const CartReccomendationsDesktop = document.querySelector('#CartReccomendations-Desktop');
					
					// if ($(window).width() < 700) {
					// 	CartReccomendationsMobile.innerHTML = recommendations.innerHTML;
					// } else {
					// 	CartReccomendationsDesktop.innerHTML = recommendations.innerHTML;						
					// }
					
					$('.cart-recommendations').addClass('loaded');
				}
				
				
			})
			.then((complete) => {
				//recommendations = $('#related-products').html();
				//$('#CartReccomendationsDT').append(recommendations);
				//$('#related-products').hide();
			})
			
			$('#cart-loader span').removeClass('loading');
			//$('.additional-checkout-buttons').addClass('loaded');
			$('.payment-options').addClass('loaded');
							
			lucky_dip_promo(checkout_value.dataset.total, cartRows);
			
			/*
			fetch(url_hard)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				
				console.log( text )
				
				let recommendations = html.querySelector('#related-products');
				recommendations = recommendations.children;
			
				if ( recommendations.length != 0 ) {
					
					console.log( recommendations )
					//$('#cart-upsell .grid').html( recommendations );
					//$('#cart-upsell').fadeIn()
				}				
			}) 
			.catch(e => {
				console.error(e);
			});
			*/
			
			/*
			fetch('/products/dinkum-dolls-pea?sections=related-products')
			.then(response => response.text())
			.then(html => {
				//console.log(JSON.parse(html))
				parsedHTML = JSON.parse(html)
				//console.log('new cart:')
				var section = 'related-products'
				const parsedSection = parsedHTML[section]
				var parser = new DOMParser();
				var sectionHTML = parser.parseFromString(parsedSection, 'text/html');

				const secion_wrap = sectionHTML.getElementById('product-recommendations');
				console.log( secion_wrap )
			}) 
			.catch(e => {
				console.error(e);
			});*/
		}
	}) 
	.catch(e => {
		console.error(e);
	});
	
	fetch(window.Shopify.routes.root + 'cart.js')
	.then(response => response.json())
	.then(data => update_cart_count(data) );
}

$('#CartDrawer').on('click', '.cart-qty-input button', function () {
	const $input = $(this).siblings('.cart-qty-input input'); // Find the input element

	if ( $(this).hasClass('qty-plus') ) {
		$input.val(parseInt($input.val()) + 1);
	} else {
		var newValue = parseInt($input.val()) - 1;
		$input.val(newValue);
	}
	$input.trigger('change');
});

$('#CartDrawer').on('click', '.cart__remove', function (e) {
	e.preventDefault();
	$(this).closest('.cart__row').find('.cart-qty-input input').val('0').trigger('change');
});


$('#CartDrawer').on('change', '.cart-qty-input input', function () {
	console.log('clicked');
    cart_item_qty = $(this).val()
    cart_item_line = $(this).closest('.cart__row').data('cartitem-line')
	
	console.log( cart_item_qty )
	console.log( cart_item_line )

    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: {
            quantity: cart_item_qty,
            line: cart_item_line
        },
        success: function (cart) {
            //console.log(cart)
            update_cart_drawer()
        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            console.log("Error: " + response);
            update_cart_drawer();
        }
    }).done(function () {
        //any done functions?
    });
});


$('#CartContainer').on('change', '.cart-variants select', function() {
	var clicked_btn = $(this)
	selected_id = $(this).val(); 
	
	$.ajax({
		url: '/cart/add.js', 
		dataType: 'json',
		type: 'post',
		data: {
			quantity: 1, 
			id: selected_id
		}, 
		success: function(itemData) {
			clicked_btn.closest('.cart-variants').html('<button type="button" class="btn" disabled>added</button>');			
		}, 
		error: function(XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log("Error: " + response);
		}
	});	
});


$('.js-cartdrawer-overlay').click(function(){
	$('#CartDrawer .drawer__close button').trigger('click')
	$('.js-drawer-open-left #NavDrawer .drawer__close button').trigger('click')
});

//Collection infinity scrolling
if (document.querySelector('.more') !== null) {
	var pInfScrLoading = false;
	var pInfScrDelay = 100;
	var loadingCollection = false;
 
	function pInfScrExecute() {		
				
		var loadingImage;
		loadingCollection = true 
		pInfScrNode = $('.more').last();	
		pInfScrURL = $('.more a').last().attr("href");
		
		if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
			$.ajax({
				type: 'GET',
				url: pInfScrURL,
				beforeSend: function() {
					pInfScrLoading = true;
					loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0497/8277/files/loader.gif?v=1618948654" />');
					loadingImage.insertAfter(pInfScrNode);
					pInfScrNode.remove(); 
				},
				success: function(data) {
					// remove loading feedback
					pInfScrNode.next().remove();
					var filteredData = $(data).find(".collection-grid");
					filteredData.insertBefore( $("#product-list-foot") );
					loadingImage.remove();	
					pInfScrLoading = false;
					 											
					setTimeout(function(){ 
						loadingCollection = false 
					}, 1500); 
					bold_copyright();
					
				},
				dataType: "html"
			});
		}
	}

	$(window).scroll(function(){
		function elementScrolled(elem){
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height() + 400;
			var elemTop = $(elem).offset().top;
						
			return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
		}

		if ($('.more').length) {
			if (elementScrolled('.more')) {	
				if (loadingCollection == false) {	
					pInfScrExecute();
				}
			}
		}
	});

	$('.more a').click(function(e){
		e.preventDefault();
		pInfScrExecute();
	});
}


function email_validate($form, emailaddressVal, custPreferences, countryVal, phoneVal, sms_consent){
	$(".error").remove();
	hasError = false
		
	var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

	if (emailaddressVal == '') {
		error_message = 'Please enter an email address'
		$form.find('.k_id_email').append('<p class="error">Please enter your email address.</p>');
		hasError = true;
	} else if (!emailReg.test(emailaddressVal)) {
		$form.find('.k_id_email').append('<p class="error">Enter a valid email address.</p>');
		hasError = true;
	}	
	
	if ( $form.find('.cust-preferences').length ) {	
		if (custPreferences.length === 0) {
			$form.find('.cust-preferences').append('<p class="error">Please select at least 1 preference.</p>')
			hasError = true;
		}
	}
	
	const form_phone = $form.find('.k_id_phone')
	if (typeof form_phone !== 'undefined' && form_phone.hasClass("required") ) {
		let min_required = 8;
		
		if ( countryVal == '+61' || countryVal == '+64') {
			min_required = 9;
		}
		
		if (phoneVal.length < min_required) {
			$form.find('.k_id_phone').append('<p class="error">Please enter a valid mobile number.</p>')
			hasError = true;
		} 
	}
	
	if (sms_consent == false) {
		$form.find('.sms-consent').append('<p class="error">Please accept marketing.</p>')
		hasError = true;
	} 
	
	return hasError
}

$('.email_signup').submit(function(e) {
	e.preventDefault();
				
	const
		$form = $(this),
		emailaddressVal = $form.find('.k_id_email input').val(),
		discount = $form.data('discount'),
		data_source = $form.data('source'),
		data_success = $form.data('success'),
		data_success_title = $form.data('successtitle'),
		data_list = $form.data('list'),
		data_newsetter = $form.data('newsletter'),
		sms_consent_obj = $form.find('.sms-consent input');
	
	let
		phoneVal = $form.find('.k_id_phone input').val(),
		countryVal = '+'+$form.find('.k_country_id option:selected').val(),
		custPreferences = [];
		
	$form.find('.cust-preferences input[type="checkbox"]:checked').each(function () {
	    custPreferences.push($(this).val());		
	});
	
	let region_pref = $form.find('input[name="cust-tag-region"]:checked').val()
	if ( region_pref == 'uk' ) {
		klaviyo_list = klaviyo_uk
	} else if ( region_pref == 'us' ) { 
		klaviyo_list = klaviyo_us
	} else if ( region_pref == 'eu' ) {
		klaviyo_list = klaviyo_eu
	} else if ( region_pref == 'au' ) {
		klaviyo_list = klaviyo_au
	}
	
	if (typeof data_list !== 'undefined') {
		klaviyo_list = data_list
	}
		
	let sms_consent = true
	if ( sms_consent_obj.length ) {
		if ( sms_consent_obj.not(':checked').length ) {
			sms_consent = false
		}
	}
	
	//console.log( sms_consent )
	
	if ( region_pref != store_location ) {
		$('#new-location').fadeIn();
		
		/*ga('send', 'event', { 
			eventCategory: 'Geo Location',
			eventAction: 'Marketing popup',
			eventLabel: 'Region change'
		});*/
	}
	
	success_title = 'Thanks for joining the fun.'
	if (typeof data_success_title !== 'undefined') {
		success_title = data_success_title
	}
	
	email_validate($form, emailaddressVal, custPreferences, countryVal, phoneVal, sms_consent);
	
	let shopify_tags = ''
	for (var i = 0; i < custPreferences.length; i++) {
		shopify_tags = shopify_tags + custPreferences[i] + ',';
	}
	
	if (typeof phoneVal == 'undefined') {
		phoneVal = ''
		countryVal = ''
	}

	success_message = "<p>To receive "+signup_discount+" off your first order over "+free_shipping_min+", simply enter your discount code below during checkout:</p>"
	
	if ( hasError == false ) {
		$.ajax({
			"async": true,
            "crossDomain": true,
            "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
            "method": "POST",
            "headers": {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
            },
			"data": {
				"g": klaviyo_list,
				"$fields": "$phone_number, sms_consent, $first_name, $last_name, $source, Shopify Tags",
				"email": emailaddressVal,
				"$phone_number": countryVal+phoneVal,
				"$first_name": $form.find('.k_id_fname input').val(),
				"$last_name": $form.find('.k_id_lname input').val(),
				"Shopify Tags": shopify_tags,
				"$source": data_source,
				"sms_consent": sms_consent
			},
			"success": function(response){
				//console.log(response)
				$form.find('.header').hide();

				if ( discount == true ) {
					$form.html("<div class='email-success'><h3>"+success_title+"</h3>"+success_message+"<p><b>"+success_code+"</b></p></div>")
				} else {
					$form.html("<div class='email-success'><h3>"+success_title+"</h3><p>"+data_success+"</p><button class='newsletter-reset btn'>ADD ANOTHER EMAIL</button></div>")
					
					$('.newsletter-reset').click(function(){
						window.location.reload();
					});
				}
			},
			error: function(response){
				console.log(response)
			}
		});
	}
});


// accordion scripts
$(function() {
  var accordionHeaders = $('.accordion-header'),
      accordionContents = $('.accordion-content'),
      firstAccordionDefaultOpen = false;

  if(firstAccordionDefaultOpen) {
    accordionHeaders.first().addClass('active');
    accordionContents.first().addClass('active').show();
  }

  $('.accordion-header').on("click", function() {
    var $this = $(this),
        content = $this.next(".accordion-content");

    accordionHeaders.not($this).removeClass('active');
    accordionContents.not(content).removeClass('active').slideUp();

    $this.toggleClass('active');
    content.toggleClass('active').slideToggle();
  });
});


//Header Message Bar Countdown
//UTC HOUR

if (typeof header_countdown !== 'undefined') {
	if (store_location == 'au') {
		var day = 11
		var hour = 07
	} else if (store_location == 'uk') {
		var day = 10
		var hour = 21
	} else if (store_location == 'eu') {
		var day = 10
		var hour = 22
	} else if (store_location == 'us') {
		var day = 10
		var hour = 13
	}

	var current_date = new Date();
	var offset = parseInt(-current_date.getTimezoneOffset() / 60)

	//console.log('offset: '+offset)
	/*
	if ( offset == 13 ) {
	//NZ Daylight savings
	offset = offset -1
	}*/

	//Offset store from UTC
	if (store_location == 'au') {
		offset = offset - 10
	} else if (store_location == 'uk') {
		offset = offset - 0
	} else if (store_location == 'eu') {
		offset = offset - 1
	} else if (store_location == 'us') {
		offset = offset + 8
	}

	hour = hour + offset

	if ( hour >= 24 ) {
		day = 14 
		hour = hour - 24
	}

	//console.log('day: '+ day + 'hour: '+ hour)

	function get_time_zone_offset( ) {
		var current_date = new Date(); 
		//console.log('offset :'+ parseInt(-current_date.getTimezoneOffset() / 60) )
	}

	get_time_zone_offset()

	$('#countdown').countdown('2021/06/11 '+hour+':00:00').on('update.countdown', function(event) {	
		var $this = $(this).html(event.strftime(''
		+ '<div class="day"><span>%-d</span> Day </div>'
		+ '<div><span>%H</span>:</div>'
		+ '<div><span>%M</span>:</div>'
		+ '<div><span>%S</span></div>'));
	
		cd_day = event.strftime('%-d')
	
		if ( cd_day == '0') {
			$('#countdown .day').hide()
		}
	});
}

function isInViewport(node) {
  var rect = node.getBoundingClientRect()
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

var dinkum_parralax = $('.dinkum-parallax')

if (dinkum_parralax.length) {
	if ($(window).width() > 700) {
		$(window).scroll(function() {
			var scrolled = $(window).scrollTop()
			$('.dinkum-parallax').each(function(index, element) {
				var initY = $(this).offset().top
				var height = $(this).height()
				var endY  = initY + $(this).height()
				var scale = height / 65

				// Check if the element is in the viewport.
				var visible = isInViewport(this)
				if(visible) {
					var diff = scrolled - initY
					var ratio = Math.round((diff / height) * 100)
					$(this).css('background-position','center ' + parseInt(-(ratio * scale)) + 'px')
				}
			})
		})
	}
}

if (window.location.href.indexOf('/collections/halloween') != -1) {
	$("#halloween-products-slider").owlCarousel({
		items:1,
		nav:true,
		autoplay:false,
		dots:false,
		autoplaySpeed: 2000,
		smartSpeed: 500,
		stagePadding: 0, 
		margin: 30,
		loop: true, 
		lazyLoadEager:0,
		autoHeight:true,
		lazyLoad:true, 
		responsive : { 
			// breakpoint from 0 up
			0 : {
				items:1,
				stagePadding: 80,
				margin: 10,
				loop: true, 
				lazyLoadEager:1,
				dots:false,
				nav:false
			}, 
			// breakpoint from 600 up
			600 : {
				items:2,
				stagePadding: 0,
				loop: true, 
				dots:false,
				nav:true 
			},
			// breakpoint from 990 up
			990 : {
				items:4,
				loop: false, 
			}
		}
	});
}

$('#promo-popup a').click(function(){
	/*ga('send', 'event', { 
		eventCategory: 'Marketing',
		eventAction: 'Promo Popup',
		eventLabel: 'Clicked'
	}); */
});

let video_loops = []

$('video[data-loop]').each(function(i) {
	video_data = {
		id: $(this).attr('id'),
		loop: 0,
		loop_max: $(this).data('loop')
	}
	video_loops.push(video_data)
	
	this.addEventListener('ended', function () {
		var current_video = this;
		var $current_video = $(this);
		var video_id = $(this).attr("id");
	
		$.each(video_loops, function( i, video ) {
			if ( video.id == video_id ) {
				if (video.loop == video.loop_max ) {
					$current_video.fadeOut();
				} else {
					current_video.play();
					video.loop = video.loop + 1
				}
			}
		});						
	});
}); 

if (getCookie("a-b-test") == 0 ){
	var $section = $('#block-885e2748-1db8-408e-91ec-9f86c28250ba').remove();	
} else {
	var $section = $('#block-926406d9-d08d-4f5f-aaa6-108da15567b9').remove();		
}


$('.daydream-products .cta').click(function(e){
	e.preventDefault();
	$(this).hide();
	$('.poem').addClass('open')
});

//wrap copyright words in <b> tags
$.fn.wrapInTag = function(opts) {
  var tag = opts.tag || 'strong'
    , words = opts.words || []
    , regex = RegExp(words.join('|'), 'gi') // case insensitive
    , replacement = '<'+ tag +'>$&</'+ tag +'>';

  return this.html(function() {
    return $(this).text().replace(regex, replacement);
  });
};

function bold_copyright(){
	$('.collection-product h4 span, #product-name span').wrapInTag({
		tag: 'b',
		words: ['Dinkum Dogs','Dinkum Dolls','Cozy Dinkums','Holdie']
	});
} 
/* Disabled for now
bold_copyright();
*/
 
$('.christmas-delivery-btn').click(function(){
	$('.christmas-delivery-notes').slideDown();
	$('.christmas-delivery-btn').hide();
});

$('.close-xmas-dates').click(function(){
	$('.christmas-delivery-notes').slideUp();
	$('.christmas-delivery-btn').show();
});

//Spin the wheel competition

window.onCloseAfterWin = function(onCloseAfterWin) {
	
	console.log( onCloseAfterWin )
};

window.onWin = function(winObj) {
	
	console.log( winObj )

	/*
	This is to add a free product directly to cart
	
	var getRule = winObj && winObj.couponRules && winObj.couponRules.get;
	var productIdToAdd = null;

	if (getRule) {
	var product = getRule.applyTo.list[0];
	productIdToAdd = product && product.id;
	productToAdd = product && product.name;
	}


	console.log( getRule )
	console.log( productIdToAdd )

	if ( productToAdd == "Rattan Mushroom Basket") {
	handle = 'mushroom-basket'
	}
	  
	jQuery.getJSON(window.Shopify.routes.root + 'products/'+handle+'.js', function(product) {
	console.log( product.variants[0].id);
  
	if (productIdToAdd) {
	// Add product to cart
	fetch('/cart/add.js', {
	method: 'POST',
	credentials: 'same-origin',
	headers: {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest'
	},
	body: JSON.stringify({
	id: product.variants[0].id,
	qty: 1
	})
	});
	}
	});
	*/
};

const 	emoji_ranges = [
	'[\u2000-\u3300]',
	'\ud83c[\ud000-\udfff]',
	'\ud83d[\ud000-\udfff]',
	'\ud83e[\ud000-\udfff]',
	'\u00a9',
	'\u00ae'
]

function cart_msg_update(this_input) {
	if ( event.which != 13 ) {
		$('#char-left').html( 150 - this_input.val().length );	
	}
	
	//line_1 U+1F300 to U+1F3FF
	//line_2 U+1F400 to U+1F64F
	//line_3 U+1F680 to U+1F6FF
			
	without_emoji = this_input.val().replace(new RegExp(emoji_ranges.join('|'), 'g'), '')
	this_input.val(without_emoji)
}

// Gift Cards In development
$('#CartGiftMsg').bind('change keyup', function(event) {
	cart_msg_update($(this));
});

$('#CartContainer').on('change keyup', '#CartGiftMsg', function(event) {
	cart_msg_update($(this));
});

if ( gifting_enabled == 'true') {
	$('#CartContainer').on("change", '.cart-gifting input', function(){
		console.log('added GC')
	    if (this.checked) {
	        //console.log( $(this).val() );
			$.ajax({
				url: '/cart/add.js', 
				dataType: 'json',
				type: 'post',
				data: {
					quantity: 1, 
					id: $(this).val()
				}, 
				success: function(itemData) { 
					if (window.location.href.indexOf('olliella.com/cart') > -1) {
						//if on cart lets refresh
						window.location.href = "/cart";
					} else {
						//else show message popup
						$('#gc-popup').addClass('active');
					}
				}, 
				error: function(XMLHttpRequest) {
					var response = eval('(' + XMLHttpRequest.responseText + ')');
					response = response.description;
					console.log("Error: " + response);
				}
			});	
		
	    } else {
			$.ajax({
				url: '/cart/change.js', 
				dataType: 'json',
				type: 'post',
				data: {
					quantity: 0, 
					id: $(this).val(),
					note: ""
				}, 
				success: function(itemData) { 
					if (window.location.href.indexOf('olliella.com/cart') > -1) {
						//if on cart lets refresh
						location.reload();
					}
				}, 
				error: function(XMLHttpRequest) {
					var response = eval('(' + XMLHttpRequest.responseText + ')');
					response = response.description;
					console.log("Error: " + response);
				}
			});
	    }
	});

	function format_gift_msg(message,note_obj){
		
		//Emojis should already be removed but just double check
		message = message.replace(new RegExp(emoji_ranges.join('|'), 'g'), '')
	
		let new_lines = []
		let lines = message.split(/\n/);
		
		lines.forEach((line, index) => {
			if (typeof line !== 'undefined') {
			
				var string = line,
				length = string.length,
				step = 30,
				i = 0,
				j;
				//console.log( length )
				
				while (i < length) {
					j = string.indexOf(" ", i + step);
					if (j === -1) {
						j = length;
					}

					new_lines.push(string.slice(i, j));
					i = j;
				}
				
				if (length == 0) {
					console.log('yes')
					new_lines.push(" ");						
				}
			}
		});
	
		if ( new_lines.length > 0 ) {
			new_lines.forEach((line, i) => {
				//Need to add limit of 12 lines max 1000 character max
				if ( typeof line != 'undefined' && line != 'undefined' ) {
					if ( i == 0) {
						new_line_string = $.trim(line);
					} else {
						new_line_string = new_line_string + "\n" + $.trim(line);				
					}
				}
			});	
			//$('#CartGiftMsg').val( new_line_string )
		}
	 
		return 'startgiftmsg*'+new_line_string+'*endgiftmsg';
	
	}

	$('#checkout-btn').click(function(e) {
		//return false;
		if ( $('#CartGiftMsg').val().length != 0 ) {
			const formatted_message = format_gift_msg( $('#CartGiftMsg').val() );
			console.log( formatted_message )
			$('#CartSpecialInstructions').val( formatted_message )
		} else {
			console.log( 'no message' );
			return true; 
		}	
	});

	$('#save-gift-message').click(function(e) {
		//return false;
		if ( $('#CartGiftMsg').val().length != 0 ) {
			const formatted_message = format_gift_msg( $('#CartGiftMsg').val() );
			console.log( formatted_message )
			$('#CartSpecialInstructions').val( formatted_message )
			$('#save-gift-message').html('saving');
			$('.update-cart').trigger('click');
		} else {
			console.log( 'no message' );
		}	
	});

	$('#gc-save').click(function(){
		if ( $('#CartGiftMsg').val().length != 0 ) {
			const formatted_message = format_gift_msg( $('#CartGiftMsg').val() );
			console.log( formatted_message )
		
			$.ajax({
				url: '/cart/update.js',
				type: 'POST',
				data: {
					note: formatted_message
				},
				success: function(result) { 
					//success
					update_cart_drawer();
					update_mini_cart();
				},
				error: function(jqxhr, status, exception) {
					//failure
				}
			});
		}
		$('#gc-popup').removeClass('active');
	});

	$('#gc-close').click(function(){
		$('#gc-popup').removeClass('active');
	});
	
	$('#CartContainer').on('click', '.edit-gc-message', function(e) {
		e.preventDefault();
		console.log('clicked')
		$('#gc-popup').addClass('active');
	});
	$('#cart-dropdown').on('click', '.edit-gc-message', function(e) {
		e.preventDefault();
		$('#gc-popup').addClass('active');
	});	
}



$('#signup-trigger-btn button').click(function(){
	$('#signup-trigger-btn').slideUp()
	$('#newsletter-signup-form').slideDown();
});

$('#featured-collection-1-btn').click(function(){
	$('.featured-products-nav button').removeClass('active');
	$(this).addClass('active');
	$('#featured-collection-2').removeClass('active');
});

$('#featured-collection-2-btn').click(function(){
	$('.featured-products-nav button').removeClass('active');
	$(this).addClass('active');
	$('#featured-collection-2').addClass('active');

});


/*== Basic Product Page Bundle Function == */
$('body').on('click', '.AddBundleToCart', function(e) {
	e.preventDefault();
	
	$(this).html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>')
	
	bundle_items = [];
	
	var bundle_form = $(this).closest('.bundle-form');
	var bundle_type = $(this).closest('.collection-product').find('h4 span').text();
	if (bundle_type == '') {	
		//if we are on product page
		bundle_type = $('#product-name h2').text();
	}
		
	if ( bundle_form.data('type') == 'basic') {
		bundle_form.find('option').each(function() {
			bundle_items.push( $(this).val() );
		});
	} else {
		bundle_form.find('select').each(function() {
			bundle_items.push( $(this).find('option:selected').val() );
		}); 
	}
	
	//console.log(bundle_items)
	Shopify.moveAlong = function() {
		if (bundle_items.length) {
			var request = bundle_items.shift();

			dataObj = {        
				quantity: 1, 
				id: request,
			};
			//console.log(dataObj)

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: dataObj,
				success: function(res){
					//console.log("added: " + request);
					
					/*ga('send', 'event', { 
						eventCategory: 'Add To Cart',
						eventAction: 'Bundle',
						eventLabel: bundle_type
					});*/
					
					Shopify.moveAlong();
				},
				error: function(error){
					console.log(error);
					console.log("error: " + request);
					Shopify.moveAlong()
				}
			});
		}
		else {
			// If the queue is empty, show confirmation popup
			//console.log('completed - success')
			window.location.href = "/cart";
		}
	};
	Shopify.moveAlong();	
});


/*== Holdie Bespoke Bundle Function == */

var $holdie_bundle_owl = $("#holdie-bundle-slider");
var holdie_bundle_owl = $holdie_bundle_owl.owlCarousel({
	items:1,
	nav:false,
	autoplay:false,
	dots:false,
	autoplaySpeed: 2000,
	smartSpeed: 500,
	loop:false, 
	lazyLoad: true,
	mouseDrag: false,
	touchDrag: false
});

$('.bundle-selector button').click(function(){
	//console.log( $(this).data('toggle') )
	
	$('.bundle-selector button').removeClass('selected')
	$('.content-playtime-pack-folk, .content-playtime-pack-animals').hide();
	
	if ($(this).data('toggle') == 'folk' ) {
		holdie_bundle_owl.trigger('to.owl.carousel', 1)
		$('.bundle-selector [data-toggle="folk"').addClass('selected')
		$('.content-playtime-pack-folk').fadeIn();
		
		$('.bundle-feature.playtime-pack-folk').addClass('active')
		$('.bundle-feature.playtime-pack-animals').removeClass('active')
	} else {
		holdie_bundle_owl.trigger('to.owl.carousel', 0)
		$('.bundle-selector [data-toggle="animals"]').addClass('selected')
		$('.content-playtime-pack-animals').fadeIn();

		$('.bundle-feature.playtime-pack-folk').removeClass('active')
		$('.bundle-feature.playtime-pack-animals').addClass('active')

	}
})

function count_b_items(b_handle){
	
	const b_panel = $('.bundle-panel-inner.content-'+b_handle);
	
	const 
		b_items = b_panel.find('.bundle-item'),
		add_b_products = b_panel.find('.add-holdie-bundle');
	
	b_panel.find('.bundle-goals p').hide();
	if ( b_items.length == 2 ) {
		b_panel.find('.b_goal-1, .b_goal-2-upsell').show();
	}
	if ( b_items.length == 3 ) {
		b_panel.find('.b_goal-2').show();
	}
	
	if ( b_items.length > 1 ) {
		add_b_products.prop("disabled", false).text('Add To Cart')
	} else {
		add_b_products.prop("disabled", true).text('Choose your products')
		b_panel.find('.b_goal-1-upsell').show();
	}
}

$('.add-to-holdie-bundle').click(function(){	
	const
		b_handle = $(this).closest('.bundle-group').data('bundle'),
		selected_img = $(this).closest('.bundle-product').find('img').data('img'),
		selected_id = $(this).val(),
		remove_btn = '<button class="remove-holdie-item btn" type="button">×</button>';
		
	const
		b_panel = $('.bundle-panel-inner.content-'+b_handle),
		image = $('<img>').attr('src', selected_img),
		content = $('<li>').attr('class','bundle-item').attr('data-id',selected_id).append(image).append(remove_btn);
	
	b_panel.find('.bundle-placeholder').first().replaceWith(content);
	count_b_items(b_handle);
});

$('.bundle-panel-container').on('click', '.remove-holdie-item', function(e) {
	const b_handle = $(this).closest('.bundle-panel-inner').data('bundle');
	$(this).closest('.bundle-list').append('<li class="bundle-placeholder"></li>');
	$(this).closest('.bundle-item').remove();
	
	count_b_items(b_handle);
});

function addProductsToCart(selected_variants,button,add_form){
	Shopify.moveAlong = function() {
		if (selected_variants.length) {
			var variant_data = selected_variants.shift();

			//console.log(dataObj)

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: variant_data,
				success: function(res){
					//console.log( res)
					//console.log("added: " + variant_data);
					Shopify.moveAlong();
				},
				error: function(error){
					console.log(error);
					console.log("error: " + variant_data);
					Shopify.moveAlong()
				}
			});
		}
		else {
			// If the queue is empty, show confirmation popup
			//console.log('completed - success')
			//window.location.href = "/cart";			
			button.prop("disabled", false).text('Add To Cart');

			add_form.find('.bundle-success').fadeIn()
			
			setTimeout(function() {
				add_form.find('.bundle-success').slideUp()
			}, 3000);
			
			update_mini_cart()
			
			fetch(window.Shopify.routes.root + 'cart.js')
			.then(response => response.json())
			.then(data => update_cart_count(data) );
		}
	};
	Shopify.moveAlong();
}

$('.add-holdie-bundle').click(function(){
	
	const b_handle = $(this).closest('.bundle-panel-inner').data('bundle');
	const button = $(this);
	const add_form = button.closest('.bundle-panel-inner');
	let selected_variants = [];
	
	const pack_size = add_form.find('.bundle-item').length;
	
	const dt = new Date();
	const bundle_id = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
	
	
	add_form.find('.bundle-item').each(function(index) {		
		selected_variant = {
			quantity: 1, 
			id: $(this).data('id'),
			properties: {
				'_bundle_id': bundle_id+'_'+b_handle,
				'_bundle': b_handle+'_x'+pack_size
			}
		}
		selected_variants.push(selected_variant)
	});
	
	button.prop("disabled", true).html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>');
	
	addProductsToCart(selected_variants,button,add_form)
});


$('#add-multi-select-bundle').click(function(){
	
	const add_form = $('.bundle-panel');
	const b_handle = add_form.data('bundle');
	const button = $(this);
	let selected_variants = [];
		
	const dt = new Date();
	const bundle_id = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
	
	add_form.find('.bundle-item').each(function(index) {		
		selected_variant = {
			quantity: 1, 
			id: $(this).data('id'),
			properties: {
				'_bundle_id': bundle_id+'_'+b_handle,
				'_bundle': b_handle
			}
		}
		selected_variants.push(selected_variant)
	});
	
	button.prop("disabled", true).html('<span class="loader delay-2"></span><span class="loader delay-1"></span><span class="loader"></span>');
	addProductsToCart(selected_variants,button,add_form)
});

function remove_bundle(button){
	button.hide();  

	var obj = JSON.parse( button.attr("data-keys") );
	//console.log( obj )
	
	$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		data: {
			updates:obj
		},
		dataType: 'json',
		success: function(res){
			update_cart_drawer();
			update_mini_cart();
		}

	});
}
$('.bundle-group-trigger').click(function(){
	$('.bundle-group').removeClass('active-group');
	$(this).next('.bundle-group').addClass('active-group');
});

function toggle_bundle_step(b_step){
	const placeholders = $('.bundle-placeholder');
	
	console.log( placeholders.length )	
	
	if ( placeholders.length > 0 ) {
		$('#add-multi-select-bundle').prop("disabled", true).text('Build Your Bundle')		
		$('.bundle-group').removeClass('active-group');
		
		if ( b_step == 0 ) {
			$('.bundle-group.step-1').addClass('active-group');
		} else if ( b_step == 1 ) {
			$('.bundle-group.step-2').addClass('active-group');
		} else if ( b_step == 2 ) {
			$('.bundle-group.step-3').addClass('active-group');
		}
	} else {
		$('#add-multi-select-bundle').prop("disabled", false).text('Add To Cart')
	}
}

$('.add-bundle-option').click(function(){	
	const
		b_option = $(this).closest('.bundle-group').data('option'),
		b_step = $(this).closest('.bundle-group').data('step'),
		selected_img = $(this).closest('.bundle-product').find('img').attr('src'),
		selected_id = $(this).val();
		
	const
		option_item = $('.bundle-list [data-option='+b_option+']'), 
		image = $('<img>').attr('src', selected_img),
		remove = $('<button>').attr('type', 'button').text('×'),
		content = $('<li>').attr('class','bundle-item').attr('data-id',selected_id).attr('data-option',b_option).attr('data-step',option_item.data('step')).append(image).append(remove);
	
	option_item.replaceWith(content);
	toggle_bundle_step(b_step);
});

$('.bundle-list').on('click', '.bundle-item', function (event) {
	const
		bundle_item = $(this).closest('.bundle-item'),
		b_step = parseInt(bundle_item.data('step')) - 1;
	
	bundle_item.attr('data-id','').removeClass('bundle-item').addClass('bundle-placeholder');
	bundle_item.find('img, button').remove();
	
	console.log('test:'+b_step)
	toggle_bundle_step(b_step);
});

$('#cart-button').hover(
	function() {	  
		if (document.getElementById('loading-cart') != null) {
			update_mini_cart()
		}
	}, function() {
		//hover out
	}
);

$('.cart__remove-bundle').click(function(e){	
	remove_bundle($(this))
});

$('#cart-dropdown').on('click', '.cart__remove-bundle', function(e) {
	remove_bundle($(this))
});
$('#CartDrawer').on('click', '.cart__remove-bundle', function(e) {
	remove_bundle($(this))
});

$('#cart-dropdown').on('click', '.cart__remove', function (e) {
    e.preventDefault();
    cart_item_id = $(this).closest('.cart__row').data('cartitem-line')
	console.log( 'remove: '+ cart_item_id)

    $.ajax({
        url: '/cart/change?line='+cart_item_id+'&quantity=0',
        dataType: 'json',
        type: 'post',
        success: function (cart) {
            //console.log(cart)
            update_mini_cart()
			
			fetch(window.Shopify.routes.root + 'cart.js')
			.then(response => response.json())
			.then(data => update_cart_count(data) );
        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            console.log("Error: " + response);
        }
    }).done(function () {
        //any done functions?
    });
});

$('#cart-dropdown').on('click', '.view-cart-btn', function (e) {
    e.preventDefault();	
	$('.js-drawer-open-right').trigger('click');
});


/*== General Custom Bundle Function == */


var $giftcard_owl = $("#giftcard-slideshow");
var giftcard_owl = $giftcard_owl.owlCarousel({
	items:1,
	nav:true,
	autoplay:false,
	dots:false,
	autoplaySpeed: 2000,
	smartSpeed: 500,
	loop:false, 
	lazyLoad: true,
	lazyLoadEager: 1,
	autoplayTimeout:5000,
	startPosition: 1,
	responsive : { 
		// breakpoint from 0 up
		0 : {
			dots:true,
			nav:true,
			stagePadding: 60
		},
		// breakpoint from 600 up
		600 : {
			dots:false,
			nav:true,
			margin: 60,
			stagePadding: 0
		}
	}		
});

giftcard_owl.on('changed.owl.carousel', function(event) {
	$(".owl-item").removeClass("prev-sibling");
	
	setTimeout(
		function() 
		{
			//do something special
			// Select the .owl-item.active element
			const activeElement = $('.owl-item.active');

			// Get the previous sibling of the .owl-item.active element
			const previousSibling = activeElement.prev('.owl-item');

			// Do something with the previous sibling element
			previousSibling.addClass('prev-sibling');
		}, 100);
	
})

let gc_design = '';

function select_gc_option(){
	setTimeout(function() {
		gc_value = $('#valueSelect option:selected').val();
		console.log(gc_value + ' / '+gc_design);
		
		if (gc_value == '$0'){
			$('#AddToCart').prop("disabled", true)
		} else {
			$('#AddToCart').prop("disabled", false)			
		}
		$('#productSelect option:contains('+gc_design+' / '+gc_value+')').prop('selected', true);
		$('.selected-giftcard-value').html(gc_value);
	}, 200);
}

function gc_step_1(){
	$('.giftcard-breadcrumbs').slideDown();
	$('.yellow-star').fadeOut();
	$('.white-star').fadeIn();

	select_gc_option();
	$('.giftcard-intro').fadeOut();
	$('.giftcard-choose-message').fadeOut();
	$('.giftcard-choose-value').fadeOut();
	
	setTimeout(function() {
		if ($(window).width() < 700) {
			window.scrollTo(0, 0);
		}
		$('.giftcard-choose-design').fadeIn();
	}, 500);
	
	$('.giftcard-breadcrumbs .step').removeClass('active');
	$('.giftcard-breadcrumbs .giftcard-step-1').addClass('active');
}

$('.giftcard-step-1').click(function(){
	gc_step_1();
})

function gc_step_2(){
	select_gc_option();
	$('.giftcard-intro').fadeOut();
	$('.giftcard-choose-design').fadeOut();
	$('.giftcard-choose-value').fadeOut();
	
	setTimeout(function() {
		if ($(window).width() < 700) {
			window.scrollTo(0, 0);
		}
		$('.giftcard-choose-message').fadeIn();
	}, 500);
	
	$('.giftcard-breadcrumbs .step').removeClass('active');
	$('.giftcard-breadcrumbs .giftcard-step-2').addClass('active');
}
 
$('.giftcard-choose-design .btn').click(function(){
	gc_step_2();
	
	const gc_design_img = $('.owl-item.active').find('.giftcard-design');
	const gc_design_src = gc_design_img.attr('src');

	gc_design = gc_design_img.attr('alt');
	
	$('#selected-giftcard-1').attr("src", gc_design_src);
	$('#selected-giftcard-2').attr("src", gc_design_src);
	$('#giftcard-design-img').val('https:'+gc_design_src)
});

$('.giftcard-step-2').click(function(){
	gc_step_2();
});


function gc_step_3(){
	select_gc_option();
	$('.giftcard-intro').fadeOut();
	$('.giftcard-choose-message').fadeOut();
	$('.giftcard-choose-design').fadeOut();
	
	setTimeout(function() {
		if ($(window).width() < 700) {
			window.scrollTo(0, 0);
		}
		$('.giftcard-choose-value').fadeIn();
	}, 500);
	
	$('.giftcard-breadcrumbs .step').removeClass('active');
	$('.giftcard-breadcrumbs .giftcard-step-3').addClass('active');
}

$('.giftcard-step-3').click(function(){
	gc_step_3();
});

$('.giftcard-choose-message .btn.continue').click(function(){
	$('#giftcard-to').html( $('#recipient-name').val() );
	$('#giftcard-message').html( $('#message').val() );
});

$('#valueSelect').on('change', function() {
	select_gc_option();
});

$('#Recipient-Checkbox').change(function() {	
	if ( $('#Recipient-Checkbox').is(':checked') ){
	    $('#Recipient-Info-Wrap').slideDown()
	} else {
		$('#Recipient-Info-Wrap').slideUp()
	}
}); 

function gc_msg_update(this_input) {
	if ( event.which != 13 ) {
		$('#gc-char-left').html( 200 - this_input.val().length );	
	}
			
	without_emoji = this_input.val().replace(new RegExp(emoji_ranges.join('|'), 'g'), '')
	this_input.val(without_emoji)
}

$('#message').bind('change keyup', function(event) {
	gc_msg_update($(this));
});

if ( $('#spin-wheel').length ) {
	var spin_wheel_popup = getCookie("spinwheel-viewed");
	if (spin_wheel_popup != "") { 
		//popup viewed so do nothing
	} else {			
		setTimeout(function(){
			$("#spin-wheel").trigger("click");
			//document.getElementById("spin-wheel").onclick();
			setCookie("spinwheel-viewed", 'yes', 30);
		}, 2000); 
	}
}

let color_scheme = 'No preference'
if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
	color_scheme = 'Dark';
}
else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
	color_scheme = 'Light'
}

gtag('event', 'User preference', {
  'Color scheme': color_scheme
});

let review_check_count = 0;

function check_reviews(){
	review_length = $('.okeReviews-review-main-content-body').length;
	
	if ( review_length == 0 && review_check_count != 6 ) {
		review_check_count = review_check_count + 1
		setTimeout(function(){
			check_reviews()
		}, 1000);
	} else {
		$('#customer-review').html( $('.okeReviews-review-main-content-body').first().html() )
		$('#customer-review-name').html($('.okeReviews-review-reviewer-profile-name').first().html() )		
		$('#customer-review-stars').html($('.okeReviews-review-meta').first().html() )		
	} 
}

check_reviews()

function toggleBundleItems(el){
	const bundle_container = $(el).closest('.cart-bundle-items');
	
	bundle_container.find('.cart-bundle-list').slideToggle();
	bundle_container.find('.hide-items, .show-items').toggle();
}


$("#christmas-products-carousel").owlCarousel({
	items:2,
	nav:true,
	autoplay:false,
	dots:false,
	smartSpeed: 500,
	stagePadding: 10, 
	margin: 10,
	loop: false, 
	lazyLoadEager:0,
	autoHeight:false,
	lazyLoad:true, 
	responsive : { 
		// breakpoint from 0 up
		0 : {
		}, 
		// breakpoint from 600 up
		600 : {
		},
		// breakpoint from 990 up
		990 : {
			items:3,
			nav:true,
			dots:false
		},
		// breakpoint from 1200 up
		1200 : {
			items:4
		}
	}
}); 
setTimeout(function() {
	if (getCookie("bookmark-clicked") != 'true' ) {
		$('.bookmark-img').addClass('active')
	}
}, 3000);
$('.bookmark-img').click(function(){
	setCookie("bookmark-clicked", 'true', 7); 
}); 


const dozySoundBar = document.getElementById('dozy-sound-bar');
const dozyPlayButtons = document.querySelectorAll('.dozy-audio-btn');
const dozyAudio = document.getElementById('dozy-audio');

dozyPlayButtons.forEach(dozyPlayButton => {
  dozyPlayButton.addEventListener('click', () => {
    if (!dozyPlayButton.classList.contains('active')) {
      dozyAudio.play();
      dozyPlayButton.classList.add('active');
      dozySoundBar.classList.add('active');
    } else {
      dozyAudio.pause();
      dozyPlayButton.classList.remove('active');
      dozySoundBar.classList.remove('active');
    }
  });
});

const buyNowButton = document.getElementById('BuyNow');
if ( buyNowButton ) {
	buyNowButton.addEventListener('click', function() {
	
		const productSelect = document.getElementById('productSelect');
	
	
		fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: JSON.stringify({
				quantity: 1,
				id: productSelect.value
			})
		}).then((response) => {
			return new Promise((resolve) => response.json()
			.then((json) => resolve({
				status: response.status,
				ok: response.ok,
				json,
			})));
		}).then(({ status, json, ok }) => {
			switch (status) {
			case 400:
				console.log('no product available');
				break;
			case 201:
				break;
			case 200:
				console.log('product added');
				console.log(json);
				window.location.href = '/checkout'; 

				break;
			case 500:
				break;
			default:
				//Any default tasks
			}
		})
	});
}
	
document.addEventListener('DOMContentLoaded', function() { // Ensure DOM is ready
	const moreButton = document.querySelector('#prod-desc-more');
	const lessButton = document.querySelector('#prod-desc-less');
	const productDescription = document.querySelector('.product-description');

	if (moreButton){
		moreButton.addEventListener('click', function() {
			productDescription.classList.remove('compressed');
			moreButton.style.display = 'none';
			lessButton.style.display = 'block';
		});
		
		lessButton.addEventListener('click', function() {
			productDescription.classList.add('compressed');
			moreButton.style.display = 'block';
			lessButton.style.display = 'none';
		});
	}
});


const CollectionNavAccordians = document.querySelectorAll('.collection-nav-menu .accordion');

CollectionNavAccordians.forEach(accordion => {
	accordion.addEventListener('click', function(event) {
		const collection_nav = event.target.closest('.collection-nav-menu');
		
		const panels = collection_nav.querySelectorAll('.panel');
		const accordians = collection_nav.querySelectorAll('.accordion');
		const nextPanel = event.target.nextElementSibling
		
		panels.forEach(panel => {
			if (panel !== nextPanel) { 
				panel.style.maxHeight = ""
			} else {
			}
		});
		accordians.forEach(accordian => {
			if (accordian !== event.target) { 
				accordian.classList.remove('active');
			}
		});
	});
});